/* SPERKOW – Charm Studio v11 (2026-10-12): základ a charmy pod sebou, sestava jako samostatný přehled s cenou.
 * v10 (2026-10-12): kroky jako záložky, vidět je vždy jen jeden.
 * v9 (2026-10-12): Nejprodávanější bez písmen a pestřejší.
 * v8 (2026-10-12): menší charmy na náhledu, ?tvar=naramek|nahrdelnik z menu.
 * v7 (2026-10-12): plynulé tažení charmu po řetízku, sekce Nejprodávanější,
 *   písmena na konci nabídky, nový výběr barvy (vše je chirurgická ocel, takže „barva“, ne „kov“).
 * v6 (2026-10-12): kompaktní náhled jako lepivá karta, kroky 01–03 pod sebou,
 *   karty základů s vyčištěnými fotkami, počítadlo −/+ na charmech, plovoucí lišta s cenou.
 * v5 (2026-10-12): editor jako aplikace (posouvá se jen panel), barva charmu na dlaždici,
 *   kategorie se zvýrazňují při posouvání, třpytky, vzhled odolný proti stylům tématu.
 * v4 (2026-10-12): čištění fotek od dodavatele (text, kóty, přechodové pozadí),
 *   vyrovnané velikosti charmů, opravy tažení na mobilu, fronta zpracování fotek, rychlejší nabídka.
 * v3 (2026-10-11): barva charmu nezávislá na řetízku, nadpisy kategorií
 * Čitelný zdroj; nahrává se do motivu tak, jak je (Shopify ho posílá zkomprimovaný).
 * Souřadnice scény: čtverec 400 × 400 („frame“), charm visí háčkem v bodě (x, y).
 */
(() => {
  'use strict';

  const METALS = {
    silver: { name: 'Stříbrná', dot: 'linear-gradient(135deg,#fff,#c9ced5 45%,#7d848e)', line: '#a9afb7', stops: ['#ffffff', '#dfe3e8', '#9ea5ae', '#5d646d'] },
    gold: { name: 'Zlatá', dot: 'linear-gradient(135deg,#fff3c8,#d9b25f 45%,#8a6526)', line: '#c9a050', stops: ['#fff4cc', '#e6c477', '#b68c3c', '#77561c'] },
    rose: { name: 'Rosé', dot: 'linear-gradient(135deg,#ffe7db,#dca089 45%,#8d5443)', line: '#cf927b', stops: ['#ffe9de', '#e6ad94', '#b87560', '#7a4636'] }
  };
  const SHAPES = { nahrdelnik: 'Náhrdelník', naramek: 'Náramek' };
  const STORE_KEY = 'spw-charm-studio-v2';
  const SLOT_GAP = 50;      // auto režim: vzdálenost bodů v jednotkách scény
  const CHARM_W = 44;       // šířka charmu v jednotkách scény (11 %)

  const metalOf = (s) => {
    s = String(s || '');
    if (/ros[eé]|růž|ruz/i.test(s)) return 'rose';
    if (/zlat|gold/i.test(s)) return 'gold';
    if (/stříbr|stribr|silver|ocel/i.test(s)) return 'silver';
    return null;
  };
  const TOP = 'Nejprodávanější';
  const TOP_N = 8;          // kolekce charmů je v Shopify řazená podle prodejnosti → prvních 8 skladem
  const CAT_ORDER = [TOP, 'Láska', 'Nebe', 'Zvířata', 'Moře', 'Ovoce', 'Květiny', 'Víra', 'Kameny', 'Vlajky', 'Ostatní', 'Písmena'];
  const CAT_INFO = {
    [TOP]: 'Tyhle si lidi věší nejčastěji',
    'Písmena': 'Iniciály pro tebe i pro ty, na kterých ti záleží',
    'Láska': 'Srdce, rty a andělé',
    'Nebe': 'Slunce, měsíc a hvězdy',
    'Zvířata': 'Malí parťáci na řetízek',
    'Moře': 'Mušle, hvězdice a perly',
    'Ovoce': 'Šťavnaté a barevné',
    'Květiny': 'Kytky, kaktusy a strom života',
    'Víra': 'Křížky a symboly',
    'Kameny': 'Kameny, medailony a porcelán',
    'Vlajky': 'Odkud jsi',
    'Ostatní': 'Mašle, boty a další radosti'
  };
  /* neznámé kategorie před Ostatní, písmena úplně na konec */
  const catRank = (k) => { const i = CAT_ORDER.indexOf(k); return i < 0 ? 500 : k === 'Ostatní' ? 900 : k === 'Písmena' ? 1000 : i; };
  const sortCats = (arr) => arr.slice().sort((a, b) => catRank(a) - catRank(b));
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  /* malá písmena bez diakritiky – „zluta“ najde „Žlutá“ */
  const fold = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
  /* „Charm Písmeno A“ → „Písmeno A“: v nabídce charmů je slovo „Charm“ navíc */
  const niceTitle = (t) => String(t || "").replace(/^\s*charm\s+/i, "").trim() || String(t || "");
  const plural = (n, one, few, many) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many);
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (tag === 'button') n.className = 'btn-reset' + (cls ? ' ' + cls : '');
    else if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const svgEl = (tag, attrs) => {
    const n = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  };
  const haptic = (ms) => { try { navigator.vibrate && navigator.vibrate(ms || 8); } catch (e) {} };

  /* ---------- ikonky pro charmy bez fotky ---------- */
  const HEART = 'M20 35C7.6 26.6 3.4 19.6 3.4 13.4 3.4 8 7.5 4.6 12.2 4.6c3.4 0 6 1.8 7.8 4.7 1.8-2.9 4.4-4.7 7.8-4.7 4.7 0 8.8 3.4 8.8 8.8 0 6.2-4.2 13.2-16.6 21.6z';
  const ICONS = [
    [/dvě srd|dve srd|hearts/i, `<path transform="translate(14 1) scale(.62)" d="${HEART}"/><path transform="translate(-1 9) scale(.74)" d="${HEART}"/>`],
    [/srd|heart|lásk/i, `<path d="${HEART}"/>`],
    [/hvězd|hvezd|star/i, '<path d="M20 2.6l4.9 11 12 1.3-9 8.1 2.6 11.8L20 28.7l-10.5 6.1 2.6-11.8-9-8.1 12-1.3z"/>'],
    [/měs|mes|moon/i, '<path d="M25.6 3.8A16.2 16.2 0 1 0 36.4 28 12.6 12.6 0 1 1 25.6 3.8z"/>'],
    [/blesk|bolt|light/i, '<path d="M23.5 2.5 8 22.5h10.2L15.6 37.5 32 16.2H21.6z"/>'],
    [/čtyř|ctyr|clover|lístek|listek/i, '<circle cx="14" cy="12.5" r="6.8"/><circle cx="26" cy="12.5" r="6.8"/><circle cx="14" cy="24.5" r="6.8"/><circle cx="26" cy="24.5" r="6.8"/><path d="M19 28.5h2.4l2.2 8.6h-2.7z"/>'],
    [/podkov|horse/i, '<path fill-rule="evenodd" d="M7 4.5h7.6v14.2a5.4 5.4 0 0 0 10.8 0V4.5H33v14.2a13 13 0 0 1-26 0z"/>'],
    [/tlap|paw/i, '<ellipse cx="20" cy="27.2" rx="9" ry="7.8"/><ellipse cx="8.8" cy="16.4" rx="3.7" ry="4.7"/><ellipse cx="15.4" cy="9.6" rx="3.7" ry="4.9"/><ellipse cx="24.6" cy="9.6" rx="3.7" ry="4.9"/><ellipse cx="31.2" cy="16.4" rx="3.7" ry="4.7"/>'],
    [/motýl|motyl|butter/i, '<path d="M19 19C14 8 4 4.5 3.2 10.6 2.6 15.6 8.5 19 13.5 19.6 7.4 21.4 5.2 28.6 10 31.2 14 33.4 18 27 19 22zM21 19C26 8 36 4.5 36.8 10.6 37.4 15.6 31.5 19 26.5 19.6 32.6 21.4 34.8 28.6 30 31.2 26 33.4 22 27 21 22z"/><rect x="18.8" y="11" width="2.4" height="21" rx="1.2"/>'],
    [/kříž|kriz|cross/i, '<path d="M16.6 3h6.8v9.6H33v6.8h-9.6V37h-6.8V19.4H7v-6.8h9.6z"/>'],
    [/mašl|masl|bow/i, '<path d="M19 19.5 4.2 10.5c-1.6 4-1.6 14.6 0 18.6zM21 19.5l14.8-9c1.6 4 1.6 14.6 0 18.6z"/><circle cx="20" cy="19.6" r="4.4"/><path d="M17.2 22.6l-3.8 13.2 3.8-1.5 2-9zM22.8 22.6l3.8 13.2-3.8-1.5-2-9z"/>'],
    [/anděl|andel|křídl|kridl|wing|angel/i, '<path d="M33 5.5C33 22 26 33 9 36.5c3.5-3 5.8-6.4 6.8-10.4-3.2.6-6.4.2-9.3-1.2 4.4-.7 8-2.4 10.7-5.1-3 0-5.8-.9-8.2-2.6 5.2-.4 9.8-2.3 13.5-5.6C25.6 8.7 29.4 6.8 33 5.5z"/>'],
    [/klíč|klic|key/i, '<path fill-rule="evenodd" d="M20 2.6a8.4 8.4 0 1 1 0 16.8 8.4 8.4 0 1 1 0-16.8zm0 4.3a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 1 0 0-8.2zM17.8 18.8h4.4V37h-4.4zM22 27.6h6.2V31H22zM22 33h4.6v3.4H22z"/>']
  ];
  let gradSeq = 0;

  /* Samostatné SVG (vlastní <defs>), aby šlo i vykreslit do obrázku. Očko je součástí kresby. */
  function iconSvg(title, metal) {
    const id = 'csg' + (++gradSeq);
    const st = METALS[metal].stops;
    let body;
    if (/perl|pearl/i.test(title)) {
      body = `<circle cx="20" cy="25" r="12.5" fill="url(#${id}p)"/><ellipse cx="15.8" cy="20.5" rx="3.6" ry="2.3" fill="#fff" opacity=".75" transform="rotate(-35 15.8 20.5)"/>`;
    } else {
      const letter = title.match(/^p[íi]smeno\s+(\S)/i) || title.match(/^(\S)$/);
      let shape = null;
      if (!letter) for (const [re, s] of ICONS) if (re.test(title)) { shape = s; break; }
      if (shape) {
        body = `<g transform="translate(4 8) scale(.8)" fill="url(#${id})" stroke="rgba(0,0,0,.28)" stroke-width=".7">${shape}</g>`;
      } else {
        const ch = (letter ? letter[1] : title.trim().charAt(0) || '•').toUpperCase().replace(/[<&>"]/g, '');
        body = `<circle cx="20" cy="24" r="13" fill="url(#${id})" stroke="rgba(0,0,0,.28)" stroke-width=".55"/><circle cx="20" cy="24" r="10.2" fill="none" stroke="rgba(0,0,0,.2)" stroke-width=".8"/><text x="20" y="29.4" text-anchor="middle" font-size="14" font-weight="700" font-family="Anton, Impact, sans-serif" fill="rgba(0,0,0,.6)">${ch}</text>`;
      }
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><defs><linearGradient id="${id}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${st[0]}"/><stop offset=".38" stop-color="${st[1]}"/><stop offset=".7" stop-color="${st[2]}"/><stop offset="1" stop-color="${st[3]}"/></linearGradient><radialGradient id="${id}p" cx=".36" cy=".32" r=".78"><stop offset="0" stop-color="#fff"/><stop offset=".55" stop-color="#efe9e0"/><stop offset="1" stop-color="#bdb3a5"/></radialGradient></defs><circle cx="20" cy="5.2" r="3.6" fill="none" stroke="url(#${id})" stroke-width="1.8"/><rect x="18.9" y="8.4" width="2.2" height="4.4" rx="1" fill="url(#${id})"/>${body}</svg>`;
  }

  /* ---------- zpracování fotek: klíčování pozadí + ořez ---------- */
  const imgCache = {};

  /* Načte obrázek, odstraní pozadí (pokud nemá průhlednost) a vrátí plátno + masku. */
  function keyImage(img, maxW) {
    const W = Math.min(maxW, img.naturalWidth);
    const H = Math.round(img.naturalHeight * W / img.naturalWidth);
    const cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    const cx = cv.getContext('2d');
    cx.drawImage(img, 0, 0, W, H);
    const id = cx.getImageData(0, 0, W, H);
    const d = id.data;
    const N = W * H;
    const mask = new Uint8Array(N);
    let transparent = 0;
    for (let i = 0; i < N; i += 3) if (d[i * 4 + 3] < 24) transparent++;
    const hasAlpha = transparent > (N / 3) * 0.06;
    if (hasAlpha) {
      for (let i = 0; i < N; i++) mask[i] = d[i * 4 + 3] > 110 ? 1 : 0;
      return { cv, mask, W, H, keyed: false };
    }
    // barva pozadí = medián okrajových pixelů
    const R = [], G = [], B = [];
    const sample = (x, y) => { const k = (y * W + x) * 4; R.push(d[k]); G.push(d[k + 1]); B.push(d[k + 2]); };
    for (let x = 0; x < W; x += 3) { sample(x, 0); sample(x, 1); sample(x, H - 1); sample(x, H - 2); }
    for (let y = 0; y < H; y += 3) { sample(0, y); sample(1, y); sample(W - 1, y); sample(W - 2, y); }
    const med = (a) => { a.sort((p, q) => p - q); return a[a.length >> 1]; };
    const br = med(R), bg = med(G), bb = med(B);
    const dark = br + bg + bb < 150;
    // světlé pozadí bývá přechod nebo vinětace – barvu pozadí odhadneme zvlášť pro každé místo
    const field = dark ? null : bgField(d, W, H, [br, bg, bb]);
    // je šperk barevný (zlato, rosé)? Pak je šedá kolem něj jen stín a může zmizet celá.
    // U stříbra je šedá samotný kov, tak se se stínem zachází opatrněji.
    let warm = 0, all = 0;
    if (!dark) for (let i = 0; i < N; i += 2) {
      const k = i * 4, r = d[k], g = d[k + 1], b = d[k + 2];
      if (Math.abs(r - field[k]) + Math.abs(g - field[k + 1]) + Math.abs(b - field[k + 2]) < 100) continue;
      all++;
      if (Math.max(r, g, b) - Math.min(r, g, b) >= 30) warm++;
    }
    const silver = all > 0 && warm / all < 0.35;
    for (let i = 0; i < N; i++) {
      const k = i * 4;
      const r = d[k], g = d[k + 1], b = d[k + 2];
      let lo, hi, cut, dist;
      if (dark) {
        // tmavé pozadí: záře kolem kovu je tmavší a méně kontrastní než kov sám
        dist = Math.abs(r - br) + Math.abs(g - bg) + Math.abs(b - bb);
        lo = 150; hi = 330; cut = 260;
      } else {
        const lr = field[k], lg = field[k + 1], lb = field[k + 2];
        dist = Math.abs(r - lr) + Math.abs(g - lg) + Math.abs(b - lb);
        const chroma = Math.max(r, g, b) - Math.min(r, g, b);
        // šedé a tmavší než pozadí = stín, nebo stříbro. Slabý stín zmizí, stříbro zůstane.
        const grey = r + g + b < lr + lg + lb && chroma < 22;
        if (!grey) { lo = 26; hi = 78; cut = 64; } else if (silver) { lo = 40; hi = 115; cut = 80; } else { lo = 80; hi = 170; cut = 150; }
      }
      const a = dist <= lo ? 0 : dist >= hi ? 255 : Math.round((dist - lo) / (hi - lo) * 255);
      if (a < d[k + 3]) d[k + 3] = a;
      mask[i] = dist > cut ? 1 : 0;
    }
    // fotky od dodavatele mají kóty a text (rozměry, kód, „Weight“) – necháme jen samotný šperk
    const keep = mainObject(mask, W, H);
    if (keep) for (let i = 0; i < N; i++) if (!keep[i]) { mask[i] = 0; d[i * 4 + 3] = 0; }
    cx.putImageData(id, 0, 0);
    return { cv, mask, W, H, keyed: true };
  }

  /* Barva pozadí pro každý pixel: mřížka 12 × 12, v každém poli průměr nejsvětlejší třetiny pixelů.
     Pole, kde je hlavně šperk (barevné nebo úplně jiné než okraj fotky), se doplní ze sousedů. */
  function bgField(d, W, H, edge) {
    const n = 12, cw = W / n, ch = H / n, esum = edge[0] + edge[1] + edge[2];
    let cells = [];
    for (let cy = 0; cy < n; cy++) for (let cx = 0; cx < n; cx++) {
      const px = [];
      for (let y = Math.floor(cy * ch); y < Math.floor((cy + 1) * ch); y += 2)
        for (let x = Math.floor(cx * cw); x < Math.floor((cx + 1) * cw); x += 2) {
          const k = (y * W + x) * 4;
          px.push([d[k] + d[k + 1] + d[k + 2], d[k], d[k + 1], d[k + 2]]);
        }
      px.sort((p, q) => q[0] - p[0]);
      const top = px.slice(0, Math.max(1, Math.round(px.length / 3)));
      const c = [0, 1, 2].map((j) => top.reduce((s, p) => s + p[j + 1], 0) / top.length);
      const ok = Math.max(...c) - Math.min(...c) < 24 && Math.abs(c[0] + c[1] + c[2] - esum) < 120;
      cells.push(ok ? c : null);
    }
    for (let pass = 0; pass < n && cells.some((c) => !c); pass++) {
      cells = cells.map((c, i) => {
        if (c) return c;
        const x = i % n, y = (i - x) / n, acc = [0, 0, 0];
        let m = 0;
        for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
          const xx = x + dx, yy = y + dy, o = cells[yy * n + xx];
          if (xx < 0 || yy < 0 || xx >= n || yy >= n || !o) continue;
          acc[0] += o[0]; acc[1] += o[1]; acc[2] += o[2]; m++;
        }
        return m ? acc.map((v) => v / m) : null;
      });
    }
    cells = cells.map((c) => c || edge);
    const out = new Uint8ClampedArray(W * H * 4);
    for (let y = 0; y < H; y++) {
      const fy = clamp((y + 0.5) / ch - 0.5, 0, n - 1), y0 = Math.min(n - 2, Math.floor(fy)), v = fy - y0;
      for (let x = 0; x < W; x++) {
        const fx = clamp((x + 0.5) / cw - 0.5, 0, n - 1), x0 = Math.min(n - 2, Math.floor(fx)), u = fx - x0;
        const a = cells[y0 * n + x0], b = cells[y0 * n + x0 + 1], c = cells[(y0 + 1) * n + x0], e = cells[(y0 + 1) * n + x0 + 1];
        const k = (y * W + x) * 4;
        for (let j = 0; j < 3; j++) out[k + j] = (a[j] * (1 - u) + b[j] * u) * (1 - v) + (c[j] * (1 - u) + e[j] * u) * v;
      }
    }
    return out;
  }

  /* Počet pixelů masky ve čtverci (2r+1)² kolem každého bodu (dvě posuvná okna). */
  function boxCount(src, W, H, r) {
    const tmp = new Uint16Array(W * H), out = new Uint16Array(W * H);
    for (let y = 0; y < H; y++) {
      const o = y * W;
      let s = 0;
      for (let x = 0; x <= Math.min(r, W - 1); x++) s += src[o + x];
      for (let x = 0; x < W; x++) {
        tmp[o + x] = s;
        if (x + r + 1 < W) s += src[o + x + r + 1];
        if (x - r >= 0) s -= src[o + x - r];
      }
    }
    for (let x = 0; x < W; x++) {
      let s = 0;
      for (let y = 0; y <= Math.min(r, H - 1); y++) s += tmp[y * W + x];
      for (let y = 0; y < H; y++) {
        out[y * W + x] = s;
        if (y + r + 1 < H) s += tmp[(y + r + 1) * W + x];
        if (y - r >= 0) s -= tmp[(y - r) * W + x];
      }
    }
    return out;
  }
  const dilate = (m, W, H, r) => { const c = boxCount(m, W, H, r), o = new Uint8Array(W * H); for (let i = 0; i < o.length; i++) o[i] = c[i] > 0 ? 1 : 0; return o; };
  const erode = (m, W, H, r) => { const c = boxCount(m, W, H, r), f = (2 * r + 1) * (2 * r + 1), o = new Uint8Array(W * H); for (let i = 0; i < o.length; i++) o[i] = c[i] >= f ? 1 : 0; return o; };

  /* Najde hlavní předmět na fotce. Tenké čáry a písmena zmizí „otevřením“ masky,
     pak se vezme největší souvislá oblast (+ velké kusy hned vedle, třeba druhá třešeň).
     Vrací masku pixelů, které se mají ponechat, nebo null (když si není jistý). */
  function mainObject(mask, W, H) {
    const N = W * H;
    const r = Math.max(1, Math.round(Math.min(W, H) / 300));
    const open = dilate(erode(mask, W, H, r), W, H, r);
    const gap = Math.max(3, Math.round(Math.min(W, H) / 70));
    const grown = dilate(open, W, H, gap);
    const lab = new Int32Array(N);
    const area = [0], box = [null];
    const stack = new Int32Array(N);
    let n = 0;
    for (let i = 0; i < N; i++) {
      if (!grown[i] || lab[i]) continue;
      n++;
      let sp = 0, a = 0, x0 = W, x1 = 0, y0 = H, y1 = 0;
      stack[sp++] = i; lab[i] = n;
      while (sp) {
        const p = stack[--sp];
        const x = p % W;
        if (open[p]) {
          a++;
          const y = (p - x) / W;
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
        if (x > 0 && grown[p - 1] && !lab[p - 1]) { lab[p - 1] = n; stack[sp++] = p - 1; }
        if (x < W - 1 && grown[p + 1] && !lab[p + 1]) { lab[p + 1] = n; stack[sp++] = p + 1; }
        if (p >= W && grown[p - W] && !lab[p - W]) { lab[p - W] = n; stack[sp++] = p - W; }
        if (p < N - W && grown[p + W] && !lab[p + W]) { lab[p + W] = n; stack[sp++] = p + W; }
      }
      area.push(a);
      box.push([x0, y0, x1, y1]);
    }
    if (!n) return null;
    let best = 1;
    for (let j = 2; j <= n; j++) if (area[j] > area[best]) best = j;
    if (area[best] < N * 0.004) return null;
    // další velké kusy (druhá třešeň, rozpadlý řetízek) jen když leží u hlavního – štítky „Weight/Metal“ pod fotkou ne
    const pad = 0.08 * Math.max(W, H), mb = box[best];
    const near = (b) => b[0] <= mb[2] + pad && b[2] >= mb[0] - pad && b[1] <= mb[3] + pad && b[3] >= mb[1] - pad;
    // řádek textu nebo štítek: nízký a široký pruh
    const textLike = (b) => b[3] - b[1] < 0.07 * H && b[2] - b[0] > 2.5 * (b[3] - b[1]);
    const ok = area.map((a, j) => j === best || (j > 0 && a >= area[best] * 0.22 && near(box[j]) && !textLike(box[j])));
    const sel = new Uint8Array(N);
    for (let i = 0; i < N; i++) if (open[i] && ok[lab[i]]) sel[i] = 1;
    // vrátíme jen okraj, který „otevření“ ubralo – čáry kót, které se předmětu dotýkají, zůstanou pryč
    return dilate(sel, W, H, r + 2);
  }

  function bbox(mask, W, H, minRun) {
    let x0 = W, x1 = -1, y0 = H, y1 = -1;
    for (let x = 0; x < W; x++) {
      let c = 0;
      for (let y = 0; y < H; y++) c += mask[y * W + x];
      if (c > minRun) { if (x < x0) x0 = x; x1 = x; }
    }
    for (let y = 0; y < H; y++) {
      let c = 0;
      for (let x = 0; x < W; x++) c += mask[y * W + x];
      if (c > minRun) { if (y < y0) y0 = y; y1 = y; }
    }
    return x1 < 0 ? null : { x0, x1, y0, y1 };
  }

  /* Zpracování fotek běží ve frontě po jedné, aby se stránka nesekala (charmů je přes sto).
     Fotka řetízku má přednost. */
  const jobs = [];
  let jobsOn = false;
  function runJobs() {
    if (jobsOn) return;
    jobsOn = true;
    const step = () => {
      const job = jobs.shift();
      if (!job) { jobsOn = false; return; }
      job().then(() => setTimeout(step, 0));
    };
    setTimeout(step, 0);
  }

  function loadImage(url, process, cb, urgent) {
    let e = imgCache[url];
    if (e) { e.status === 'loading' ? e.cbs.push(cb) : cb(e); return; }
    e = imgCache[url] = { status: 'loading', cbs: [cb] };
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    const done = () => { const cbs = e.cbs; e.cbs = []; cbs.forEach((f) => f(e)); };
    img.onload = () => {
      const job = () => Promise.resolve()
        .then(() => process(e, img, url))
        .then(() => { e.status = 'ok'; }, (err) => {
          e.status = 'fail';
          try { console.warn('Charm Studio – obrázek:', err && err.message); } catch (x) {}
        })
        .then(done);
      urgent ? jobs.unshift(job) : jobs.push(job);
      runJobs();
    };
    img.onerror = () => { e.status = 'fail'; done(); };
    img.src = url;
  }

  /* Plátno → adresa obrázku. toBlob je rychlejší než toDataURL a neblokuje stránku. */
  function canvasUrl(cv) {
    return new Promise((res) => {
      if (!cv.toBlob) { res(cv.toDataURL('image/png')); return; }
      cv.toBlob((b) => res(b ? URL.createObjectURL(b) : cv.toDataURL('image/png')), 'image/png');
    });
  }

  /* Fotka řetízku: klíčování, umístění do scény a vystopování spodní linie. */
  function processChain(e, img, url) {
    const k = keyImage(img, 720);
    e.src = url;
    const ready = k.keyed ? canvasUrl(k.cv).then((u) => { e.src = u; }) : Promise.resolve();
    traceChain(e, k);
    return ready;
  }

  function traceChain(e, k) {
    const { W, H, mask } = k;
    e.natW = W; e.natH = H;
    // výchozí umístění: celá fotka vepsaná do scény
    const s0 = Math.min(380 / W, 380 / H);
    e.rect = { x: 200 - W * s0 / 2, y: 200 - H * s0 / 2, w: W * s0, h: H * s0 };
    e.traced = false;
    const bb = bbox(mask, W, H, 2);
    if (!bb || bb.x1 - bb.x0 < 0.15 * W || bb.y1 - bb.y0 < 0.08 * H) return;
    const bw = bb.x1 - bb.x0 + 1, bh = bb.y1 - bb.y0 + 1;
    const sc = Math.min(366 / bw, 300 / bh);
    const oy = (bh * sc < 300 ? 292 - bh * sc : -8) - bb.y0 * sc;
    const ox = 200 - (bb.x0 + bw / 2) * sc;
    e.rect = { x: ox, y: oy, w: W * sc, h: H * sc };
    // spodní okraj řetízku po sloupcích → střed tloušťky
    const step = Math.max(1, Math.round(bw / 180));
    const raw = [], th = [];
    for (let x = bb.x0; x <= bb.x1; x += step) {
      let yb = -1;
      for (let y = bb.y1; y >= bb.y0; y--) if (mask[y * W + x]) { yb = y; break; }
      if (yb < 0) continue;
      let t = 0;
      for (let y = yb; y >= bb.y0 && mask[y * W + x]; y--) t++;
      raw.push([x, yb, t]);
      if (x > bb.x0 + 0.3 * bw && x < bb.x1 - 0.3 * bw) th.push(t);
    }
    th.sort((a, b) => a - b);
    const thick = clamp(th.length ? th[th.length >> 1] : 6, 3, 0.03 * W);
    const mid = raw.map((p) => [p[0], p[1] - Math.min(p[2], thick) / 2]);
    const pts = [];
    for (let i = 0; i < mid.length; i++) {
      let sx = 0, sy = 0, n = 0;
      for (let j = Math.max(0, i - 4); j <= Math.min(mid.length - 1, i + 4); j++) { sx += mid[j][0]; sy += mid[j][1]; n++; }
      pts.push([sx / n * sc + ox, sy / n * sc + oy]);
    }
    if (pts.length < 12) return;
    let ymin = 1e9, ymax = -1e9;
    pts.forEach((p) => { ymin = Math.min(ymin, p[1]); ymax = Math.max(ymax, p[1]); });
    // charmy jen na spodní část řetízku – na bocích by visely mimo scénu
    const yCut = ymin + 0.5 * (ymax - ymin);
    const len = [0];
    for (let i = 1; i < pts.length; i++) len.push(len[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    const total = len[len.length - 1];
    let a = -1, b = -1;
    pts.forEach((p, i) => { if (p[1] >= yCut) { if (a < 0) a = i; b = i; } });
    let r0 = a < 0 ? 0.15 : len[a] / total + 0.02;
    let r1 = b < 0 ? 0.85 : len[b] / total - 0.02;
    if (r1 - r0 < 0.3) { r0 = 0.15; r1 = 0.85; }
    e.pts = pts; e.r0 = r0; e.r1 = r1; e.traced = true;
  }

  /* Fotka charmu: klíčování + ořez na neprůhlednou část, aby horní okraj = očko. */
  function processCharm(e, img, url) {
    const k = keyImage(img, 320);
    const bb = bbox(k.mask, k.W, k.H, 0);
    if (!bb) { e.src = url; e.ar = 1; return; }
    const pad = 2;
    const x0 = Math.max(0, bb.x0 - pad), y0 = Math.max(0, bb.y0 - pad);
    const w = Math.min(k.W, bb.x1 + pad + 1) - x0, h = Math.min(k.H, bb.y1 + pad + 1) - y0;
    const out = document.createElement('canvas');
    out.width = w; out.height = h;
    out.getContext('2d').drawImage(k.cv, x0, y0, w, h, 0, 0, w, h);
    e.ar = h / w;
    e.cv = out;
    return canvasUrl(out).then((u) => { e.src = u; });
  }

  /* Fotky charmů mají různé měřítko. Vysoké charmy (klíč, váleček) zúžíme,
     aby na řetízku nepřerostly ostatní; široké nechá být. */
  const sizeFactor = (ar) => (ar > 1 ? +Math.pow(ar, -0.7).toFixed(3) : 1);

  /* ---------- polyline helpery ---------- */
  function polyline(pts) {
    const len = [0];
    for (let i = 1; i < pts.length; i++) len.push(len[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    return { pts, len, total: len[len.length - 1] };
  }
  function pointAt(pl, d) {
    const L = pl.len;
    d = clamp(d, 0, pl.total - 0.001);
    let lo = 0, hi = L.length - 1;
    while (hi - lo > 1) { const m = (lo + hi) >> 1; if (L[m] <= d) lo = m; else hi = m; }
    const u = (d - L[lo]) / (L[hi] - L[lo] || 1);
    const a = pl.pts[lo], b = pl.pts[hi];
    return { x: a[0] + (b[0] - a[0]) * u, y: a[1] + (b[1] - a[1]) * u, ang: Math.atan2(b[1] - a[1], b[0] - a[0]) };
  }
  const bezier = (p, t) => {
    const n = 1 - t;
    return [0, 1].map((k) => n * n * n * p[0][k] + 3 * n * n * t * p[1][k] + 3 * n * t * t * p[2][k] + t * t * t * p[3][k]);
  };

  /* ---------- body ručně: metafield custom.charm_points ---------- */
  function parsePoints(v) {
    try {
      if (typeof v === 'string') v = JSON.parse(v);
      if (v && !Array.isArray(v)) v = v.points || v.body || null;
      if (!Array.isArray(v)) return null;
      const pts = v.map((p) => Array.isArray(p) ? [Number(p[0]), Number(p[1])] : [Number(p.x), Number(p.y)])
        .filter((p) => isFinite(p[0]) && isFinite(p[1]));
      return pts.length >= 1 ? pts : null;
    } catch (e) { return null; }
  }

  /* =================================================================== */
  function init(root) {
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    const sid = root.getAttribute('data-sid');
    const dataEl = document.getElementById('cs-data-' + sid);
    if (!dataEl) return;
    let cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const $ = (k) => root.querySelector('[data-cs="' + k + '"]');
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const maxSetting = clamp(parseInt(cfg.max, 10) || 9, 3, 14);
    let money;
    try {
      money = new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: cfg.currency || 'CZK', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } catch (e) { money = { format: (v) => Math.round(v) + ' Kč' }; }
    const fmt = (cents) => money.format(cents / 100);

    /* ---------- data ---------- */
    let demo = false;
    let rawBases = (cfg.bases || []).filter(Boolean);
    let rawCharms = (cfg.charms || []).filter(Boolean);
    if (!rawBases.length) {
      demo = true;
      const v = (id, t, price, metal) => ({ id, t, o: [t], price, cmp: 0, av: true, img: null, metal });
      rawBases = [
        { pid: 'd1', title: 'Řetízek Anker', type: 'Řetízek', tags: '', eds: [], first: null, th: null, points: null, promo: true,
          vars: [v('b1', 'Stříbrná', 49900), v('b2', 'Zlatá', 54900)] },
        { pid: 'd2', title: 'Náramek Anker', type: 'Náramek', tags: 'naramek', eds: [], first: null, th: null, points: null, promo: true,
          vars: [v('b3', 'Stříbrná', 39900), v('b4', 'Zlatá', 44900)] }
      ];
    }
    if (!rawCharms.length) {
      demo = true;
      rawCharms = [['Srdce', 'Láska', 12900], ['Dvě srdce', 'Láska', 16900], ['Andělské křídlo', 'Láska', 19900], ['Hvězda', 'Nebe', 14900], ['Měsíc', 'Nebe', 14900], ['Blesk', 'Nebe', 14900], ['Čtyřlístek', 'Štěstí', 16900], ['Podkova', 'Štěstí', 16900], ['Tlapka', 'Zvířata', 14900], ['Motýl', 'Zvířata', 18900], ['Písmeno A', 'Písmena', 12900], ['Písmeno M', 'Písmena', 12900], ['Perla', 'Elegance', 17900], ['Mašle', 'Elegance', 16900], ['Křížek', 'Symboly', 13900], ['Klíč', 'Symboly', 15900]]
        .map((c, i) => ({ pid: 'c' + i, title: c[0], cat: c[1], th: null, scale: 1, promo: true, vars: [{ id: 'cv' + i, t: 'Default Title', o: [], price: c[2], cmp: 0, av: true, img: null }] }));
    }

    // Základy: každá varianta je jedna položka; skupina = produkt + kov.
    const bases = [];
    const baseById = {};
    rawBases.forEach((p) => {
      const shape = /(^|\s)n[aá]ramek(\s|$)/i.test(p.tags || '') ? 'naramek' : 'nahrdelnik';
      const pMetal = metalOf(p.title + ' ' + (p.type || '') + ' ' + (p.tags || '')) || 'silver';
      const eds = (p.eds || []).filter(Boolean);
      // název volby, která není kov (Délka, Typ, Velikost…) – podle něj se pojmenuje řádek s variantami
      const opts = p.opts || [];
      const optName = opts.find((o, i) => !/barva|kov|color|metal|title/i.test(o) && (p.vars || []).some((v) => (v.o || [])[i] && !metalOf(v.o[i]))) || '';
      (p.vars || []).forEach((v) => {
        const metal = v.metal || metalOf(v.t) || pMetal;
        const label = (v.o || []).filter((o) => !metalOf(o) && o !== 'Default Title').join(' / ');
        // fotka do editoru: alt „editor (kov)“ → fotka varianty → první fotka produktu
        const ed = eds.find((im) => metalOf(im.a) === metal) || eds.find((im) => !metalOf(im.a));
        const stage = (ed && ed.u) || v.img || p.first || null;
        const b = {
          id: String(v.id), pid: String(p.pid), title: p.title, sub: label, optName, price: v.price, cmp: v.cmp || 0, av: !!v.av,
          th: p.th || null, stage, shape, metal, group: p.pid + '|' + metal,
          points: parsePoints(p.points), promo: !!p.promo
        };
        bases.push(b);
        baseById[b.id] = b;
      });
    });

    const charms = [];
    const charmById = {};
    const charmByVariant = {};
    rawCharms.forEach((p) => {
      const c = {
        pid: String(p.pid), title: niceTitle(p.title), cat: p.cat || 'Ostatní', th: p.th || null,
        scale: clamp(Number(p.scale) || 1, 0.4, 2.5), promo: !!p.promo,
        vars: (p.vars || []).map((v) => ({ id: String(v.id), metal: metalOf(v.t), price: v.price, cmp: v.cmp || 0, av: !!v.av, img: v.img || p.th || null }))
      };
      if (!c.vars.length) return;
      c.search = fold(p.title + ' ' + c.cat);
      c.av = c.vars.some((v) => v.av);
      charms.push(c);
      charmById[c.pid] = c;
      c.vars.forEach((v) => { charmByVariant[v.id] = c; });
    });

    /* Varianta charmu pro daný kov. Vždy dáme přednost kusu skladem, aby košík nehlásil vyprodáno:
       shodný kov skladem → bez kovu skladem → cokoli skladem → shodný kov → první. */
    function charmVar(c, metal) {
      const v = c.vars;
      return v.find((x) => x.metal === metal && x.av) || v.find((x) => !x.metal && x.av) || v.find((x) => x.av) ||
        v.find((x) => x.metal === metal) || v[0];
    }
    /* Barvu charmu vypíšeme, když jich má víc, nebo když se liší od řetízku. */
    const showMetal = (c, v) => !!v.metal && (metalsOf(c).length > 1 || v.metal !== curMetal());
    /* Kovy, ve kterých charm je skladem (pořadí: zlatá, stříbrná, rosé). */
    function metalsOf(c) {
      const pool = c.av ? c.vars.filter((v) => v.av) : c.vars;
      return ['gold', 'silver', 'rose'].filter((m) => pool.some((v) => v.metal === m));
    }

    /* ---------- stav ---------- */
    const S = { base: null, items: [], sel: null, target: null, q: '', tab: 'base' };
    const firstBase = bases.find((b) => b.av) || bases[0];
    S.base = firstBase ? firstBase.id : null;
    let uidSeq = 0;
    const uid = () => 'u' + (++uidSeq);
    const undoStack = [], redoStack = [];
    let geo = null;
    const nodes = {};   // uid → element charmu
    const swing = {};   // uid → {a, w}
    let drag = null;
    let shownTotal = null;
    let picker = null;
    const tileMetal = {}; // pid → barva vybraná kolečkem na dlaždici
    let tilesKey = "";

    const curBase = () => baseById[S.base] || null;
    const curMetal = () => (curBase() ? curBase().metal : 'silver');
    /* Charm má vlastní barvu (it.m), jinak ladí s řetízkem. Na dlaždici se dá barva přepnout kolečkem. */
    const itemMetal = (it) => (it && it.m) || curMetal();
    const browseMetal = (c) => (c && tileMetal[c.pid]) || curMetal();
    const curShape = () => (curBase() ? curBase().shape : 'nahrdelnik');
    const sorted = () => S.items.slice().sort((a, b) => a.t - b.t);
    const capacity = () => Math.min(maxSetting, geo ? geo.slots : maxSetting);
    const slotOf = (t) => Math.round(clamp(t, 0, 1) * Math.max(0, geo.slots - 1));
    const tOfSlot = (i) => (geo.slots <= 1 ? 0.5 : i / (geo.slots - 1));

    function snapshot() { return JSON.stringify({ b: S.base, i: S.items.map((x) => ({ uid: x.uid, pid: x.pid, t: x.t, m: x.m || null })) }); }
    function restore(json) {
      const o = JSON.parse(json);
      const baseChanged = o.b !== S.base;
      S.base = o.b; S.items = o.i; S.sel = null; S.target = null;
      if (baseChanged) ensureStage();
    }
    function pushUndo() {
      undoStack.push(snapshot());
      if (undoStack.length > 50) undoStack.shift();
      redoStack.length = 0;
    }
    function undo() {
      if (!undoStack.length) return;
      redoStack.push(snapshot());
      restore(undoStack.pop());
      S.items.forEach((x) => kick(x.uid, 6));
      renderAll();
      toast('Vráceno zpět');
    }
    function redo() {
      if (!redoStack.length) return;
      undoStack.push(snapshot());
      restore(redoStack.pop());
      renderAll();
      toast('Znovu provedeno');
    }

    /* ---------- geometrie řetízku ---------- */
    function buildGeo() {
      const b = curBase();
      const entry = b && b.stage ? imgCache[b.stage] : null;
      const ok = entry && entry.status === 'ok';
      const pts = picker && picker.active ? picker.pts : b && b.points;
      if (ok && pts && pts.length) {
        const r = entry.rect;
        const abs = pts.map((p) => [r.x + p[0] / 100 * r.w, r.y + p[1] / 100 * r.h]);
        geo = manualGeo(abs);
        geo.photo = entry;
      } else if (ok && entry.traced) {
        const pl = polyline(entry.pts);
        geo = { mode: 'auto', pl, r0: entry.r0, r1: entry.r1, photo: entry };
        geo.at = (t) => pointAt(pl, pl.total * (geo.r0 + (geo.r1 - geo.r0) * clamp(t, 0, 1)));
        geo.usable = pl.total * (geo.r1 - geo.r0);
        geo.slots = clamp(Math.floor(geo.usable / SLOT_GAP) + 1, 3, 14);
      } else {
        geo = fallbackGeo(curShape());
        // nástroj na body potřebuje fotku, i když se z ní linie nepodařilo vystopovat
        if (ok && picker && picker.active) geo.photo = entry;
      }
      geo.probe = [];
      for (let i = 0; i <= 240; i++) { const p = geo.at(i / 240); geo.probe.push([p.x, p.y, i / 240]); }
      let cx = 0, cy = 0;
      for (let i = 0; i < geo.slots; i++) { const p = geo.at(tOfSlot(i)); cx += p.x; cy += p.y; }
      geo.cx = cx / geo.slots; geo.cy = cy / geo.slots;
      $('frame').style.transformOrigin = (geo.cx / 4).toFixed(1) + '% ' + (geo.cy / 4 + 6).toFixed(1) + '%';
      normalize(null);
    }

    function manualGeo(abs) {
      const n = abs.length;
      const g = { mode: 'manual', abs, slots: n };
      g.at = (t) => {
        if (n === 1) return { x: abs[0][0], y: abs[0][1], ang: 0 };
        const f = clamp(t, 0, 1) * (n - 1);
        const i = Math.min(n - 2, Math.floor(f));
        const u = f - i;
        const a = abs[i], b = abs[i + 1];
        return { x: a[0] + (b[0] - a[0]) * u, y: a[1] + (b[1] - a[1]) * u, ang: Math.atan2(b[1] - a[1], b[0] - a[0]) };
      };
      return g;
    }

    function fallbackGeo(shape) {
      const pts = [];
      if (shape === 'naramek') {
        for (let i = 0; i <= 400; i++) { const r = i / 400 * Math.PI * 2; pts.push([200 + 142 * Math.cos(r), 168 + 74 * Math.sin(r)]); }
      } else {
        const L = [[52, -14], [46, 150], [118, 282], [200, 284]], R = [[200, 284], [282, 282], [354, 150], [348, -14]];
        for (let i = 0; i <= 200; i++) pts.push(bezier(L, i / 200));
        for (let i = 1; i <= 200; i++) pts.push(bezier(R, i / 200));
      }
      const pl = polyline(pts);
      const g = { mode: 'fallback', shape, pl };
      if (shape === 'naramek') {
        g.at = (t) => { const a = Math.PI * (0.1 + 0.8 * clamp(t, 0, 1)); return { x: 200 + 142 * Math.cos(a), y: 168 + 74 * Math.sin(a), ang: a + Math.PI / 2 }; };
        g.usable = 0.8 * Math.PI * Math.sqrt(12820);
      } else {
        g.r0 = 0.21; g.r1 = 0.79;
        g.at = (t) => pointAt(pl, pl.total * (g.r0 + (g.r1 - g.r0) * clamp(t, 0, 1)));
        g.usable = pl.total * (g.r1 - g.r0);
      }
      g.slots = clamp(Math.floor(g.usable / SLOT_GAP) + 1, 3, 14);
      return g;
    }

    function nearestOnChain(x, y) {
      let best = null, bd = 1e9;
      for (const p of geo.probe) {
        const d = (p[0] - x) * (p[0] - x) + (p[1] - y) * (p[1] - y);
        if (d < bd) { bd = d; best = p; }
      }
      return { t: best[2], d: Math.sqrt(bd) };
    }

    /* Rozdělí charmy na body: zachová pořadí, nic se nepřekrývá. pinUid drží svou pozici. */
    function normalize(pinUid) {
      if (!geo) return;
      const n = geo.slots;
      const cap = capacity();
      let arr = sorted();
      if (arr.length > cap) {
        const lost = arr.length - cap;
        arr = arr.slice(0, cap);
        S.items = S.items.filter((x) => arr.indexOf(x) > -1);
        toast(`Na tento řetízek se vejde ${cap} ${plural(cap, "charm", "charmy", "charmů")}. ${lost} ${plural(lost, "charm", "charmy", "charmů")} jsme sundali, krok zpět je vrátí.`);
      }
      const r = arr.length;
      if (!r) return;
      const out = [];
      const fill = (a, b, lo, hi) => {
        let prev = lo - 1;
        for (let k = a; k <= b; k++) {
          const s = Math.max(prev + 1, Math.min(hi - (b - k), slotOf(arr[k].t)));
          out[k] = s; prev = s;
        }
      };
      const p = arr.findIndex((x) => x.uid === pinUid);
      if (p >= 0) {
        const s = Math.max(p, Math.min(n - 1 - (r - 1 - p), slotOf(arr[p].t)));
        out[p] = s;
        fill(0, p - 1, 0, s - 1);
        fill(p + 1, r - 1, s + 1, n - 1);
      } else fill(0, r - 1, 0, n - 1);
      arr.forEach((x, k) => { x.t = tOfSlot(out[k]); });
    }

    function usedSlots() {
      const u = {};
      S.items.forEach((x) => { u[slotOf(x.t)] = 1; });
      return u;
    }
    function freeSlotNear(center) {
      if (S.items.length >= capacity()) return -1;
      const used = usedSlots();
      const c = center == null ? (geo.slots - 1) / 2 : center;
      let best = -1, bd = 1e9;
      for (let i = 0; i < geo.slots; i++) {
        if (used[i]) continue;
        const d = Math.abs(i - c) + (i < c ? 0.01 : 0);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    /* ---------- fotka základu ---------- */
    function ensureStage() {
      const b = curBase();
      buildGeo();
      drawChain();
      if (!b || !b.stage) return;
      const e = imgCache[b.stage];
      if (e && e.status !== 'loading') return;
      root.classList.add('is-loading');
      loadImage(b.stage, processChain, () => {
        root.classList.remove('is-loading');
        if (curBase() !== b) return;
        buildGeo();
        drawChain();
        renderStage();
        if (picker && picker.active) picker.render();
      }, true);
    }

    /* ---------- vykreslení řetízku ---------- */
    function drawChain() {
      const svg = $('chain');
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      const b = curBase();
      const entry = b && b.stage ? imgCache[b.stage] : null;
      if (entry && entry.status === 'loading') return;
      const photo = geo && geo.photo;
      root.classList.toggle('is-photo', !!photo);
      if (photo) {
        const r = photo.rect;
        const im = svgEl('image', { x: r.x.toFixed(2), y: r.y.toFixed(2), width: r.w.toFixed(2), height: r.h.toFixed(2), preserveAspectRatio: 'none', class: 'cs-photo' });
        im.setAttribute('href', photo.src);
        im.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', photo.src);
        svg.appendChild(im);
        return;
      }
      // kreslený řetízek
      const metal = curMetal();
      const gid = 'csl-' + sid;
      const defs = svgEl('defs', {});
      const lg = svgEl('linearGradient', { id: gid, x1: 0, y1: 0, x2: 1, y2: 1 });
      METALS[metal].stops.forEach((c, i) => lg.appendChild(svgEl('stop', { offset: [0, 0.38, 0.7, 1][i], 'stop-color': c })));
      defs.appendChild(lg);
      const blur = svgEl('filter', { id: gid + 'b', x: '-10%', y: '-10%', width: '120%', height: '140%' });
      blur.appendChild(svgEl('feGaussianBlur', { stdDeviation: 5 }));
      defs.appendChild(blur);
      svg.appendChild(defs);
      const pl = geo.pl;
      const fill = 'url(#' + gid + ')';
      svg.appendChild(svgEl('path', {
        d: 'M' + pl.pts.map((p) => p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join('L'),
        fill: 'none', stroke: '#000', 'stroke-width': 7, opacity: 0.14, transform: 'translate(0 9)', filter: 'url(#' + gid + 'b)'
      }));
      const back = svgEl('g', { opacity: 0.45 }), front = svgEl('g', {});
      const links = Math.floor(pl.total / 9.4);
      for (let i = 0; i < links; i++) {
        const m = pointAt(pl, 9.4 * i + 4.7);
        const deg = (m.ang * 180 / Math.PI).toFixed(1);
        const x = m.x.toFixed(2), y = m.y.toFixed(2);
        const g = svgEl('g', { transform: `rotate(${deg} ${x} ${y})` });
        if (i % 2) {
          g.appendChild(svgEl('rect', { x: m.x - 5.4, y: m.y - 1.5, width: 10.8, height: 3, rx: 1.5, fill, stroke: 'rgba(0,0,0,.35)', 'stroke-width': 0.5 }));
        } else {
          g.appendChild(svgEl('ellipse', { cx: x, cy: y, rx: 6.2, ry: 3.9, fill: 'none', stroke: 'rgba(0,0,0,.35)', 'stroke-width': 3.4 }));
          g.appendChild(svgEl('ellipse', { cx: x, cy: y, rx: 6.2, ry: 3.9, fill: 'none', stroke: fill, 'stroke-width': 2.3 }));
          g.appendChild(svgEl('ellipse', { cx: (m.x - 1.6).toFixed(2), cy: (m.y - 2.4).toFixed(2), rx: 2.2, ry: 0.7, fill: '#fff', opacity: 0.65 }));
        }
        (geo.shape === 'naramek' && m.y < 168 ? back : front).appendChild(g);
      }
      svg.appendChild(back);
      svg.appendChild(front);
      if (geo.shape === 'naramek') {
        const c = pointAt(pl, 0.75 * pl.total);
        svg.appendChild(svgEl('rect', { x: c.x - 10, y: c.y - 4.5, width: 20, height: 9, rx: 3.5, fill, opacity: 0.5 }));
      }
    }

    /* ---------- vizuál charmu ---------- */
    function charmVisual(c, metal) {
      const v = charmVar(c, metal);
      if (v.img) {
        const wrap = el('span', 'cs-vis cs-vis--img');
        const im = el('img');
        im.alt = '';
        im.draggable = false;
        im.decoding = 'async';
        const ready = (r) => {
          im.src = r.src;
          wrap.style.setProperty('--ar', r.ar);
          wrap.style.setProperty('--f', sizeFactor(r.ar));
          wrap.classList.remove('is-raw');
        };
        const e = imgCache[v.img];
        if (e && e.status === 'ok') ready(e); else {
          im.src = v.img;
          wrap.classList.add('is-raw');
          loadImage(v.img, processCharm, (r) => {
            if (r.status === 'ok') ready(r);
            else { wrap.className = 'cs-vis cs-vis--svg'; wrap.innerHTML = iconSvg(c.title, metal); }
          });
        }
        wrap.appendChild(im);
        return wrap;
      }
      const wrap = el('span', 'cs-vis cs-vis--svg');
      wrap.innerHTML = iconSvg(c.title, metal);
      return wrap;
    }

    /* Náhled řetízku na kartě základu: stejné čištění jako u charmů (bez textu a kót). */
    function thumbVisual(url) {
      const wrap = el('span', 'cs-vis cs-vis--img');
      const im = el('img');
      im.alt = '';
      im.draggable = false;
      const e = imgCache[url];
      if (e && e.status === 'ok') im.src = e.src; else {
        wrap.classList.add('is-raw');
        loadImage(url, processCharm, (r) => { im.src = r.status === 'ok' ? r.src : url; wrap.classList.remove('is-raw'); });
      }
      wrap.appendChild(im);
      return wrap;
    }

    /* ---------- houpání (pružina) ---------- */
    let rafOn = false, lastT = 0;
    function kick(id, w) {
      (swing[id] || (swing[id] = { a: 0, w: 0 })).w += w;
      if (!rafOn && !reduced) { rafOn = true; lastT = 0; requestAnimationFrame(tick); }
    }
    function tick(ts) {
      const dt = lastT ? Math.min(0.034, (ts - lastT) / 1000) : 0.016;
      lastT = ts;
      let live = false;
      for (const id in swing) {
        const s = swing[id];
        s.w += (-46 * s.a - 3.1 * s.w) * dt;
        s.a += s.w * dt;
        if (Math.abs(s.a) > 0.05 || Math.abs(s.w) > 0.05) live = true; else { s.a = 0; s.w = 0; }
        const n = nodes[id];
        if (n) n.style.setProperty('--a', s.a.toFixed(2) + 'deg');
      }
      if (live || drag) requestAnimationFrame(tick); else rafOn = false;
    }

    /* ---------- scéna ---------- */
    function place(node, t) {
      const p = geo.at(t);
      node.style.left = (p.x / 4) + '%';
      node.style.top = (p.y / 4) + '%';
    }

    function renderStage() {
      if (!geo) return;
      const layer = $('layer');
      const metal = curMetal();
      const keep = {};
      const order = sorted();
      S.items.forEach((it) => {
        keep[it.uid] = 1;
        const c = charmById[it.pid];
        if (!c) return;
        const im = itemMetal(it);
        const v = charmVar(c, im);
        let n = nodes[it.uid];
        if (!n || n.getAttribute('data-v') !== v.id) {
          if (n) n.remove();
          n = el('button', 'cs-ch');
          n.type = 'button';
          n.setAttribute('data-uid', it.uid);
          n.setAttribute('data-v', v.id);
          n.style.setProperty('--s', c.scale);
          n.appendChild(charmVisual(c, im));
          n.addEventListener('pointerdown', (ev) => stageDown(ev, it.uid));
          n.addEventListener('keydown', (ev) => charmKey(ev, it.uid));
          layer.appendChild(n);
          nodes[it.uid] = n;
          if (it.fresh && !reduced) {
            n.classList.add('is-drop');
            setTimeout(() => n.classList.remove('is-drop'), 700);
          }
        }
        it.fresh = false;
        n.setAttribute('aria-label', `${c.title}, pozice ${order.indexOf(it) + 1}. Šipkami posuneš, Delete sundá.`);
        n.classList.toggle('is-sel', S.sel === it.uid);
        place(n, it.t);
      });
      Object.keys(nodes).forEach((id) => {
        if (!keep[id]) { nodes[id].remove(); delete nodes[id]; delete swing[id]; }
      });
      renderSlots();
      const n = S.items.length;
      if ($('count')) $('count').textContent = n ? `${n} z ${capacity()} ${plural(capacity(), 'místa', 'míst', 'míst')}` : `Až ${capacity()} ${plural(capacity(), 'charm', 'charmy', 'charmů')}`;
      $('empty').hidden = n > 0 || !!S.target;
      $('spread').disabled = n < 2;
      $('clear').disabled = !n;
      $('undo').disabled = !undoStack.length;
      $('redo').disabled = !redoStack.length;
      renderSelCard();
    }

    function renderSlots() {
      const box = $('slots');
      box.innerHTML = '';
      if (!geo) return;
      const used = usedSlots();
      const full = S.items.length >= capacity();
      for (let i = 0; i < geo.slots; i++) {
        if (used[i]) continue;
        const b = el('button', 'cs-slot' + (S.target === i ? ' is-target' : ''));
        b.type = 'button';
        b.setAttribute('data-slot', i);
        b.setAttribute('aria-label', `Volné místo ${i + 1}. Vyber charm, který sem pověsíme.`);
        if (full) b.disabled = true;
        b.appendChild(el('span'));
        place(b, tOfSlot(i));
        b.addEventListener('click', () => {
          if (S.target === i) { S.target = null; renderStage(); return; }
          S.target = i;
          S.sel = null;
          renderStage();
          setTab('charms');
          toast('Teď vyber charm. Pověsíme ho na označené místo.');
        });
        box.appendChild(b);
      }
    }

    function renderSelCard() {
      const card = $('selcard');
      const it = S.items.find((x) => x.uid === S.sel);
      root.classList.toggle('has-sel', !!it);
      if (!it) { card.hidden = true; return; }
      const c = charmById[it.pid];
      const im = itemMetal(it);
      const v = charmVar(c, im);
      const order = sorted();
      const i = order.indexOf(it);
      card.hidden = false;
      const th = $('sel-th');
      th.innerHTML = '';
      th.appendChild(charmVisual(c, im));
      $('sel-name').textContent = c.title;
      const ms = metalsOf(c);
      const vm = v.metal || im;
      $('sel-meta').textContent = `${i + 1}. zleva · ${ms.length > 1 ? METALS[vm].name.toLowerCase() + ' · ' : ''}${fmt(v.price)}`;
      let mb = card.querySelector('[data-act="metal"]');
      if (!mb) {
        mb = el('button', 'cs-sel-metal');
        mb.type = 'button';
        mb.setAttribute('data-act', 'metal');
        mb.appendChild(el('i'));
        card.insertBefore(mb, card.querySelector('[data-act="left"]'));
      }
      mb.hidden = ms.length < 2;
      if (ms.length > 1) {
        const nx = ms[(ms.indexOf(vm) + 1) % ms.length];
        mb.querySelector('i').style.background = METALS[vm].dot;
        mb.setAttribute('aria-label', 'Změnit barvu charmu na ' + METALS[nx].name.toLowerCase());
        mb.title = 'Změnit na ' + METALS[nx].name.toLowerCase();
      }
      card.querySelector('[data-act="left"]').disabled = i <= 0 && slotOf(it.t) <= 0;
      card.querySelector('[data-act="right"]').disabled = i >= order.length - 1 && slotOf(it.t) >= geo.slots - 1;
      card.querySelector('[data-act="dup"]').disabled = S.items.length >= capacity();
    }

    function selAction(act) {
      const it = S.items.find((x) => x.uid === S.sel);
      if (!it) return;
      if (act === 'close') { S.sel = null; renderStage(); return; }
      if (act === 'metal') {
        const c = charmById[it.pid];
        const ms = metalsOf(c);
        if (ms.length < 2) return;
        const cur = charmVar(c, itemMetal(it)).metal || itemMetal(it);
        const nx = ms[(ms.indexOf(cur) + 1) % ms.length];
        pushUndo();
        it.m = nx;
        kick(it.uid, 70);
        haptic(8);
        renderAll();
        toast(c.title + ': ' + METALS[nx].name.toLowerCase());
        return;
      }
      if (act === 'del') { pushUndo(); removeItem(it.uid); return; }
      if (act === 'dup') {
        const s = freeSlotNear(slotOf(it.t));
        if (s < 0) { toast('Řetízek je plný'); return; }
        pushUndo();
        const n = { uid: uid(), pid: it.pid, t: tOfSlot(s), fresh: true, m: it.m || null };
        S.items.push(n);
        normalize(n.uid);
        S.sel = n.uid;
        kick(n.uid, 60);
        renderAll();
        return;
      }
      if (act === 'left' || act === 'right') {
        pushUndo();
        moveBy(it, act === 'left' ? -1 : 1);
        renderAll();
      }
    }

    /* Posun o jedno místo; když tam někdo visí, prohodí se. */
    function moveBy(it, dir) {
      const s = slotOf(it.t) + dir;
      if (s < 0 || s >= geo.slots) return;
      const other = S.items.find((x) => x !== it && slotOf(x.t) === s);
      if (other) { other.t = it.t; kick(other.uid, dir * -90); }
      it.t = tOfSlot(s);
      kick(it.uid, dir * 90);
      normalize(it.uid);
    }

    function charmKey(ev, id) {
      const it = S.items.find((x) => x.uid === id);
      if (!it) return;
      if (ev.key === 'Delete' || ev.key === 'Backspace') { ev.preventDefault(); pushUndo(); removeItem(id); }
      else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowRight') {
        ev.preventDefault();
        pushUndo();
        moveBy(it, ev.key === 'ArrowLeft' ? -1 : 1);
        S.sel = id;
        renderAll();
        nodes[id] && nodes[id].focus();
      }
    }

    function removeItem(id, quiet) {
      const it = S.items.find((x) => x.uid === id);
      if (!it) return;
      const n = nodes[id];
      S.items = S.items.filter((x) => x.uid !== id);
      if (S.sel === id) S.sel = null;
      if (n && !reduced) {
        n.classList.add('is-fall');
        delete nodes[id];
        setTimeout(() => n.remove(), 420);
      }
      renderAll();
      if (!quiet) toast(charmById[it.pid].title + ' sundán');
    }

    function addCharm(c, slot) {
      if (!c.av) { toast(c.title + ' je vyprodaný'); return; }
      if (S.items.length >= capacity()) {
        toast(`Na řetízek se vejde ${capacity()} ${plural(capacity(), 'charm', 'charmy', 'charmů')}`);
        return;
      }
      let s = slot != null ? slot : S.target != null ? S.target : freeSlotNear(null);
      if (s != null && usedSlots()[s]) s = freeSlotNear(s);
      if (s < 0) { toast('Řetízek je plný'); return; }
      pushUndo();
      const it = { uid: uid(), pid: c.pid, t: tOfSlot(s), fresh: true, m: tileMetal[c.pid] || null };
      S.items.push(it);
      S.target = null;
      S.sel = null;
      normalize(it.uid);
      kick(it.uid, reduced ? 0 : 140 * (Math.random() < 0.5 ? -1 : 1));
      haptic(10);
      renderAll();
      sparkle(it.t);
      const r = $('stage').getBoundingClientRect();
      if (r.bottom < 80 || r.top > window.innerHeight - 80) toast(c.title + ' přidán na řetízek');
      nudgePromo();
    }

    /* ---------- tažení po scéně ---------- */
    function toFrame(cx, cy) {
      const r = $('frame').getBoundingClientRect();
      return { x: (cx - r.left) / r.width * 400, y: (cy - r.top) / r.height * 400, inside: cx >= r.left && cx <= r.right && cy >= r.top && cy <= r.bottom };
    }

    function stageDown(ev, id) {
      if (ev.button > 0 || (picker && picker.active)) return;
      const it = S.items.find((x) => x.uid === id);
      if (!it) return;
      ev.preventDefault();
      const n = nodes[id];
      try { n.setPointerCapture(ev.pointerId); } catch (e) {}
      drag = { kind: 'stage', id, it, sx: ev.clientX, sy: ev.clientY, lx: ev.clientX, moved: false, snap: snapshot(), off: false, n };
      n.addEventListener('pointermove', stageMove);
      n.addEventListener('pointerup', stageUp);
      n.addEventListener('pointercancel', stageUp);
    }
    function stageMove(ev) {
      if (!drag || drag.kind !== 'stage') return;
      const n = drag.n;
      if (!drag.moved) {
        if (Math.hypot(ev.clientX - drag.sx, ev.clientY - drag.sy) < 5) return;
        drag.moved = true;
        n.classList.add('is-drag');
        root.classList.add('is-dragging', 'is-stagedrag');
        markGhostSlot();
        S.sel = null;
        renderSelCard();
      }
      const f = toFrame(ev.clientX, ev.clientY);
      const near = nearestOnChain(f.x, f.y);
      const dx = ev.clientX - drag.lx;
      drag.lx = ev.clientX;
      const off = near.d > 70;
      if (off !== drag.off) haptic(6);
      drag.off = off;
      $('trash').classList.toggle('is-hot', off);
      if (off) {
        n.classList.add('is-off');
        n.style.left = f.x / 4 + '%';
        n.style.top = f.y / 4 + '%';
      } else {
        // charm jede plynule po řetízku za prstem; ostatní mu jemně uhýbají na volná místa
        n.classList.remove('is-off');
        const before = slotOf(drag.it.t);
        drag.it.t = near.t;
        normalize(drag.id);
        if (slotOf(drag.it.t) !== before) { haptic(4); markGhostSlot(); }
        S.items.forEach((x) => { if (nodes[x.uid] && x !== drag.it) place(nodes[x.uid], x.t); });
        place(n, near.t);
      }
      kick(drag.id, -2.2 * dx);
    }
    /* Při tažení po scéně ukazuje jemný kroužek, kam charm po puštění dosedne. */
    function markGhostSlot() {
      if (!drag || drag.kind !== 'stage') return;
      const snap = $('snap');
      snap.hidden = false;
      place(snap, drag.it.t);
    }
    function stageUp() {
      if (!drag || drag.kind !== 'stage') return;
      const d = drag;
      drag = null;
      const n = d.n;
      n.removeEventListener('pointermove', stageMove);
      n.removeEventListener('pointerup', stageUp);
      n.removeEventListener('pointercancel', stageUp);
      n.classList.remove('is-drag');
      root.classList.remove('is-dragging', 'is-stagedrag');
      $('trash').classList.remove('is-hot');
      $('snap').hidden = true;
      if (!d.moved) {
        S.sel = S.sel === d.id ? null : d.id;
        S.target = null;
        renderStage();
        return;
      }
      undoStack.push(d.snap);
      redoStack.length = 0;
      if (d.off) { n.classList.remove('is-off'); removeItem(d.id); return; }
      kick(d.id, 30);
      renderAll();
    }

    /* ---------- tažení z nabídky na řetízek ---------- */
    function tileDown(ev, c, tile) {
      if (ev.button > 0) return;
      const touch = ev.pointerType === 'touch' || ev.pointerType === 'pen';
      if (!touch) ev.preventDefault();
      const d = { kind: 'tile', c, tile, sx: ev.clientX, sy: ev.clientY, on: false, ghost: null, timer: null, slot: null };
      drag = d;
      if (touch) d.timer = setTimeout(() => { if (drag === d) tileStart(d, d.sx, d.sy); }, 320);
      // po dlouhém podržení musí prst táhnout charm, ne posouvat stránku (jinak prohlížeč tah zruší)
      d.noScroll = (e) => { if (d.on && e.cancelable) e.preventDefault(); };
      document.addEventListener('touchmove', d.noScroll, { passive: false });
      document.addEventListener('pointermove', tileMove, { passive: false });
      document.addEventListener('pointerup', tileUp);
      document.addEventListener('pointercancel', tileUp);
    }
    function tileStart(d, x, y) {
      d.on = true;
      haptic(8);
      const g = el('div', 'cs-ghost');
      g.appendChild(charmVisual(d.c, browseMetal(d.c)));
      document.body.appendChild(g);
      d.ghost = g;
      root.classList.add('is-dragging', 'is-tiledrag');
      tileTrack(d, x, y);
    }
    function tileTrack(d, x, y) {
      d.ghost.style.transform = `translate(${x - 32}px,${y - 14}px) rotate(${clamp(1.5 * (x - (d.px || x)), -25, 25)}deg)`;
      d.px = x;
      const f = toFrame(x, y);
      const snap = $('snap');
      if (f.inside) {
        const near = nearestOnChain(f.x, f.y);
        if (near.d < 90) {
          const want = near.t * (geo.slots - 1);
          const used = usedSlots();
          let best = -1, bd = 1e9;
          for (let i = 0; i < geo.slots; i++) {
            if (used[i]) continue;
            const dd = Math.abs(i - want);
            if (dd < bd) { bd = dd; best = i; }
          }
          if (best >= 0) {
            if (d.slot !== best) haptic(4);
            d.slot = best;
            snap.hidden = false;
            place(snap, tOfSlot(best));
            return;
          }
        }
      }
      snap.hidden = true;
      d.slot = null;
    }
    function tileMove(ev) {
      const d = drag;
      if (!d || d.kind !== 'tile') return;
      if (!d.on) {
        const dist = Math.hypot(ev.clientX - d.sx, ev.clientY - d.sy);
        if (ev.pointerType === 'mouse' && dist > 6) tileStart(d, ev.clientX, ev.clientY);
        else if (ev.pointerType !== 'mouse' && dist > 9) { clearTimeout(d.timer); tileEnd(); return; }
        else return;
      }
      ev.preventDefault();
      tileTrack(d, ev.clientX, ev.clientY);
    }
    function tileEnd() {
      if (drag && drag.noScroll) document.removeEventListener('touchmove', drag.noScroll);
      document.removeEventListener('pointermove', tileMove);
      document.removeEventListener('pointerup', tileUp);
      document.removeEventListener('pointercancel', tileUp);
      drag = null;
    }
    function tileUp(ev) {
      const d = drag;
      if (!d || d.kind !== 'tile') return;
      clearTimeout(d.timer);
      tileEnd();
      $('snap').hidden = true;
      root.classList.remove('is-dragging', 'is-tiledrag');
      if (d.on) {
        // klik, který prohlížeč pošle po tažení, nesmí charm přidat podruhé;
        // když se pustí mimo dlaždici, klik nepřijde – proto pojistka přes setTimeout
        d.tile.__skip = true;
        setTimeout(() => { d.tile.__skip = false; }, 0);
        d.ghost && d.ghost.remove();
        if (d.slot != null && ev.type === 'pointerup') addCharm(d.c, d.slot);
        else if (S.items.length < capacity()) toast('Pusť charm blíž k řetízku');
      }
    }

    /* ---------- nabídka: základy ---------- */
    function chooseBase(b) {
      if (!b) return;
      if (b.id === S.base) return;
      pushUndo();
      S.base = b.id;
      S.target = null;
      ensureStage();
      S.items.forEach((x, i) => kick(x.uid, 50 * (i % 2 ? 1 : -1)));
      renderAll();
    }
    const pickBase = (pred) => bases.filter(pred).find((b) => b.av) || bases.find(pred);

    function renderBases() {
      const cur = curBase();
      const shapes = [];
      bases.forEach((b) => { if (shapes.indexOf(b.shape) < 0) shapes.push(b.shape); });
      const sh = $('shapes');
      sh.innerHTML = '';
      sh.hidden = shapes.length < 2;
      $('shaperow').hidden = shapes.length < 2;
      shapes.forEach((s) => {
        const on = cur && cur.shape === s;
        const btn = el('button', 'cs-seg' + (on ? ' is-on' : ''), SHAPES[s]);
        btn.type = 'button';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.addEventListener('click', () => {
          if (on) return;
          chooseBase(pickBase((b) => b.shape === s && b.metal === curMetal()) || pickBase((b) => b.shape === s));
        });
        sh.appendChild(btn);
      });

      const metals = [];
      bases.forEach((b) => { if (cur && b.shape === cur.shape && metals.indexOf(b.metal) < 0) metals.push(b.metal); });
      const mt = $('metals');
      mt.innerHTML = '';
      $('metalrow').hidden = metals.length < 2;
      const mn = $('metalname');
      if (mn) mn.textContent = METALS[curMetal()].name;
      metals.forEach((m) => {
        const on = curMetal() === m;
        const btn = el('button', 'cs-metal' + (on ? ' is-on' : ''));
        btn.type = 'button';
        btn.title = METALS[m].name;
        btn.setAttribute('aria-label', METALS[m].name);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        const dot = el('i');
        dot.style.background = METALS[m].dot;
        btn.appendChild(dot);
        btn.addEventListener('click', () => {
          if (on) return;
          // stejný produkt v jiném kovu, jinak jakýkoli
          chooseBase(pickBase((b) => b.pid === cur.pid && b.metal === m && b.sub === cur.sub) ||
            pickBase((b) => b.pid === cur.pid && b.metal === m) ||
            pickBase((b) => b.shape === cur.shape && b.metal === m));
        });
        mt.appendChild(btn);
      });

      // produkty = skupiny (produkt + kov)
      const list = $('bases');
      list.innerHTML = '';
      const groups = [];
      bases.forEach((b) => {
        if (!cur || b.shape !== cur.shape || b.metal !== cur.metal) return;
        if (!groups.find((g) => g.key === b.group)) groups.push({ key: b.group, items: bases.filter((x) => x.group === b.group) });
      });
      groups.forEach((g) => {
        const on = cur.group === g.key;
        const show = on ? cur : g.items.find((x) => x.av) || g.items[0];
        const av = g.items.some((x) => x.av);
        const btn = el('button', 'cs-base' + (on ? ' is-on' : ''));
        btn.type = 'button';
        btn.disabled = !av;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        const th = el('span', 'cs-base-th');
        const src = show.stage || show.th;
        if (src) th.appendChild(thumbVisual(src.replace(/width=\d+/, 'width=420'))); else {
          const i = el('i'); i.style.background = METALS[show.metal].dot; th.appendChild(i);
        }
        if (on) th.appendChild(el('span', 'cs-base-ok'));
        btn.appendChild(th);
        const tx = el('span', 'cs-base-tx');
        tx.appendChild(el('b', null, show.title));
        const minP = Math.min(...g.items.map((x) => x.price));
        const maxP = Math.max(...g.items.map((x) => x.price));
        tx.appendChild(el('small', null, !av ? 'Vyprodáno' : g.items.length > 1 ? `${g.items.length} ${plural(g.items.length, 'varianta', 'varianty', 'variant')}` : show.sub || METALS[show.metal].name));
        btn.appendChild(tx);
        const pr = el('span', 'cs-price');
        if (!on && minP !== maxP) pr.textContent = 'od ' + fmt(minP); else pr.appendChild(priceNode(show.price, show.cmp));
        btn.appendChild(pr);
        btn.addEventListener('click', () => { if (!on) chooseBase(show.av ? show : g.items.find((x) => x.av)); });
        list.appendChild(btn);
      });

      // varianty (délka / velikost) vybraného produktu
      const vrow = $('varrow');
      const vbox = $('vars');
      vbox.innerHTML = '';
      const sibs = cur ? bases.filter((x) => x.group === cur.group) : [];
      vrow.hidden = sibs.length < 2;
      const vl = $('varlbl');
      if (vl && cur) vl.textContent = cur.optName || 'Varianta';
      sibs.forEach((b) => {
        const on = b.id === cur.id;
        const btn = el('button', 'cs-pill' + (on ? ' is-on' : ''), b.sub || b.title);
        btn.type = 'button';
        btn.disabled = !b.av;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (b.price !== cur.price) btn.appendChild(el('small', null, fmt(b.price)));
        btn.addEventListener('click', () => chooseBase(b));
        vbox.appendChild(btn);
      });
    }

    function priceNode(p, cmp) {
      const f = document.createDocumentFragment();
      if (cmp > p) f.appendChild(el('s', null, fmt(cmp)));
      f.appendChild(document.createTextNode(fmt(p)));
      return f;
    }

    /* ---------- nabídka: charmy ---------- */
    /* Skupiny nabídky v pořadí: Nejprodávanější (prvních pár kusů skladem z kolekce řazené podle prodejnosti),
       pak kategorie, písmena nakonec. Při hledání se nejprodávanější nepřidávají, aby se výsledky neopakovaly. */
    function catGroups(list, withTop) {
      const groups = {};
      list.forEach((c) => { (groups[c.cat] = groups[c.cat] || []).push(c); });
      const out = sortCats(Object.keys(groups).filter((k) => k !== TOP)).map((k) => [k, groups[k]]);
      // dokud nejsou prodeje, kolekce je seřazená od nejnovějších (samá písmena) – proto bez písmen a max. 2 z kategorie
      const top = [], per = {};
      if (withTop) for (const c of list) {
        if (top.length >= TOP_N) break;
        if (!c.av || c.cat === 'Písmena' || (per[c.cat] || 0) >= 2) continue;
        per[c.cat] = (per[c.cat] || 0) + 1;
        top.push(c);
      }
      if (top.length >= 3 && out.length > 1) out.unshift([TOP, top]);
      return out;
    }

    function renderCats() {
      const cats = catGroups(charms, true);
      const box = $('cats');
      box.innerHTML = '';
      box.hidden = cats.length < 2;
      cats.forEach(([k, items]) => {
        const n = items.length;
        const b = el('button', 'cs-cat' + (k === TOP ? ' cs-cat--top' : ''), k);
        b.setAttribute('data-cat', k);
        b.setAttribute('role', 'tab');
        b.appendChild(el('sup', null, String(n)));
        b.addEventListener('click', () => jumpTo(k));
        box.appendChild(b);
      });
    }

    /* Posun panelu na skupinu kategorie. */
    function jumpTo(k) {
      if (S.q) { S.q = ''; $('q').value = ''; renderCharms(); }
      const h = $('charms').querySelector('.cs-gh[data-cat="' + k + '"]');
      if (!h) return;
      scrollToY(h.getBoundingClientRect().top + window.scrollY - stickyTop() - filterH() - 6);
      markCat(k);
    }
    const filterH = () => { const f = root.querySelector('.cs-filter'); return f ? f.offsetHeight : 0; };
    let curCat = null;
    function markCat(k) {
      if (k === curCat) return;
      curCat = k;
      $('cats').querySelectorAll('.cs-cat').forEach((b) => {
        const on = b.getAttribute('data-cat') === k;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && b.scrollIntoView) {
          const box = $('cats');
          const l = b.offsetLeft - box.offsetLeft;
          if (l < box.scrollLeft + 8 || l + b.offsetWidth > box.scrollLeft + box.clientWidth - 8) box.scrollLeft = l - 24; // okamžitě: plynulé posouvání by zrušilo plynulý posun stránky
        }
      });
    }
    /* Při posouvání nabídky se zvýrazní kategorie, ve které právě jsi. */
    function spyCats() {
      const lim = stickyTop() + filterH() + 24;
      let k = null;
      $('charms').querySelectorAll('.cs-gh').forEach((h) => { if (h.getBoundingClientRect().top <= lim || !k) k = h.getAttribute('data-cat'); });
      if (k) markCat(k);
    }

    /* Třpytky při pověšení charmu */
    function sparkle(t) {
      if (reduced || !geo) return;
      const p = geo.at(t);
      const layer = $('layer');
      for (let i = 0; i < 9; i++) {
        const sp = el('span', 'cs-spark');
        const ang = (i / 9) * Math.PI * 2 + Math.random() * 0.5;
        const d = 26 + Math.random() * 26;
        sp.style.left = p.x / 4 + '%';
        sp.style.top = (p.y + 22) / 4 + '%';
        sp.style.setProperty('--dx', Math.cos(ang) * d + 'px');
        sp.style.setProperty('--dy', Math.sin(ang) * d + 'px');
        sp.style.animationDelay = Math.random() * 120 + 'ms';
        layer.appendChild(sp);
        setTimeout(() => sp.remove(), 1100);
      }
    }

    function charmTile(c, metal) {
      const count = S.items.filter((x) => x.pid === c.pid).length;
      const v = charmVar(c, metal);
      const t = el('div', 'cs-tile' + (count ? ' is-on' : '') + (c.av ? '' : ' is-so'));
      const media = el('div', 'cs-tile-media');
      const pic = el('button', 'cs-tile-pic');
      pic.disabled = !c.av;
      pic.setAttribute('aria-label', `Přidat ${c.title} za ${fmt(v.price)}`);
      pic.appendChild(charmVisual(c, metal));
      media.appendChild(pic);
      const ms = metalsOf(c);
      const vm = v.metal || metal;
      if (ms.length > 1) {
        const sw = el('div', 'cs-tile-m');
        sw.setAttribute('role', 'group');
        sw.setAttribute('aria-label', 'Barva charmu ' + c.title);
        ms.forEach((m) => {
          const b = el('button', 'cs-sw' + (vm === m ? ' is-on' : ''));
          b.title = METALS[m].name;
          b.setAttribute('aria-label', METALS[m].name);
          b.setAttribute('aria-pressed', vm === m ? 'true' : 'false');
          const i = el('i');
          i.style.background = METALS[m].dot;
          b.appendChild(i);
          b.addEventListener('pointerdown', (ev) => ev.stopPropagation());
          b.addEventListener('click', (ev) => {
            ev.stopPropagation();
            if (vm === m) return;
            tileMetal[c.pid] = m;
            haptic(6);
            $('charms').querySelectorAll('.cs-tile[data-pid="' + c.pid + '"]').forEach((o) => o.replaceWith(charmTile(c, m)));
          });
          sw.appendChild(b);
        });
        media.appendChild(sw);
      }
      t.appendChild(media);
      t.appendChild(el('span', 'cs-tile-t', c.title));
      const pr = el('span', 'cs-price');
      pr.appendChild(priceNode(v.price, v.cmp));
      if (ms.length > 1) pr.appendChild(el('em', null, ' · ' + METALS[vm].name.toLowerCase()));
      t.appendChild(pr);
      if (!c.av) t.appendChild(el('span', 'cs-tile-so', 'Vyprodáno'));
      else {
        const q = el('div', 'cs-qty');
        const minus = el('button', 'cs-qty-b', '−');
        minus.setAttribute('aria-label', 'Sundat jeden ' + c.title);
        minus.disabled = !count;
        const plus = el('button', 'cs-qty-b', '+');
        plus.setAttribute('aria-label', 'Přidat ' + c.title);
        const n = el('b', null, String(count));
        [minus, plus].forEach((b) => b.addEventListener('pointerdown', (ev) => ev.stopPropagation()));
        minus.addEventListener('click', (ev) => {
          ev.stopPropagation();
          const mine = sorted().filter((x) => x.pid === c.pid);
          if (!mine.length) return;
          pushUndo();
          removeItem(mine[mine.length - 1].uid);
        });
        plus.addEventListener('click', (ev) => { ev.stopPropagation(); addCharm(c); });
        q.append(minus, n, plus);
        t.appendChild(q);
      }
      t.addEventListener('pointerdown', (ev) => { if (c.av) tileDown(ev, c, t); });
      t.addEventListener('contextmenu', (ev) => ev.preventDefault());
      t.addEventListener('click', () => { if (!c.av) return; if (t.__skip) { t.__skip = false; return; } addCharm(c); });
      t.setAttribute('data-pid', c.pid);
      return t;
    }

    /* Po změně sestavy stačí přepsat počty na dlaždicích, ne stavět nabídku znovu. */
    function syncTiles() {
      const cnt = {};
      S.items.forEach((x) => { cnt[x.pid] = (cnt[x.pid] || 0) + 1; });
      $('charms').querySelectorAll('.cs-tile[data-pid]').forEach((t) => {
        const n = cnt[t.getAttribute('data-pid')] || 0;
        t.classList.toggle('is-on', n > 0);
        const q = t.querySelector('.cs-qty');
        if (q) { q.querySelector('b').textContent = String(n); q.firstChild.disabled = !n; }
      });
      $('target').hidden = S.target == null;
    }

    function groupHead(k, i, n) {
      const h = el('div', 'cs-gh');
      h.setAttribute('data-cat', k);
      h.appendChild(el('span', 'cs-gh-n', String(i + 1).padStart(2, '0')));
      const tx = el('span', 'cs-gh-t');
      tx.appendChild(el('b', null, k));
      if (CAT_INFO[k]) tx.appendChild(el('small', null, CAT_INFO[k]));
      h.appendChild(tx);
      h.appendChild(el('span', 'cs-gh-c', n + ' ' + plural(n, 'kousek', 'kousky', 'kousků')));
      return h;
    }

    function renderCharms(onlyIfChanged) {
      const key = [S.q, curMetal()].join('|');
      if (onlyIfChanged && key === tilesKey) { syncTiles(); return; }
      tilesKey = key;
      const box = $('charms');
      box.innerHTML = '';
      const q = fold(S.q);
      const list = charms.filter((c) => !q || c.search.indexOf(q) > -1);
      $('target').hidden = S.target == null;
      if (!list.length) { box.appendChild(el('p', 'cs-none', 'Takový charm tu nemáme. Zkus jiné slovo, třeba „srdce“.')); return; }
      catGroups(list, !q).forEach(([k, items], gi) => {
        box.appendChild(groupHead(k, gi, items.length));
        items.forEach((c) => box.appendChild(charmTile(c, browseMetal(c))));
      });
      curCat = null;
      requestAnimationFrame(spyCats);
    }

    /* ---------- souhrn ---------- */
    function renderSummary() {
      const list = $('list');
      list.innerHTML = '';
      const b = curBase();
      const metal = curMetal();
      if (b) {
        const li = el('li', 'cs-row cs-row--base');
        const th = el('span', 'cs-row-th');
        const src = b.stage || b.th;
        if (src) th.appendChild(thumbVisual(src.replace(/width=\d+/, 'width=420'))); else { const i = el('i'); i.style.background = METALS[b.metal].dot; th.appendChild(i); }
        li.appendChild(th);
        const tx = el('span', 'cs-row-tx');
        tx.appendChild(el('b', null, b.title));
        tx.appendChild(el('small', null, METALS[b.metal].name + (b.sub ? ', ' + b.sub : '')));
        li.appendChild(tx);
        li.appendChild(el('span', 'cs-row-p', fmt(b.price)));
        list.appendChild(li);
      }
      const order = sorted();
      if (!order.length) {
        const li = el('li', 'cs-row cs-row--empty');
        li.appendChild(el('span', null, 'Zatím bez charmů. Vyber, co má šperk vyprávět.'));
        const go = el('button', 'cs-back', 'Vybrat charmy');
        go.type = 'button';
        go.addEventListener('click', () => setTab('charms'));
        li.appendChild(go);
        list.appendChild(li);
      }
      order.forEach((it, i) => {
        const c = charmById[it.pid];
        const im = itemMetal(it);
        const v = charmVar(c, im);
        const li = el('li', 'cs-row');
        li.appendChild(el('span', 'cs-row-i', String(i + 1)));
        const th = el('span', 'cs-row-th');
        th.appendChild(charmVisual(c, im));
        li.appendChild(th);
        const tx = el('span', 'cs-row-tx');
        tx.appendChild(el('b', null, c.title));
        tx.appendChild(el('small', null, (showMetal(c, v) ? METALS[v.metal].name + ' · ' : '') + (c.cat || '')));
        li.appendChild(tx);
        li.appendChild(el('span', 'cs-row-p', fmt(v.price)));
        const ctr = el('span', 'cs-row-ctl');
        const mk = (label, txt, fn, dis) => {
          const btn = el('button', 'cs-row-b', txt);
          btn.type = 'button';
          btn.setAttribute('aria-label', label);
          btn.disabled = !!dis;
          btn.addEventListener('click', fn);
          ctr.appendChild(btn);
        };
        mk('Posunout doleva', '‹', () => { pushUndo(); swapWith(it, order[i - 1]); }, i === 0);
        mk('Posunout doprava', '›', () => { pushUndo(); swapWith(it, order[i + 1]); }, i === order.length - 1);
        mk('Sundat ' + c.title, '×', () => { pushUndo(); removeItem(it.uid); });
        li.appendChild(ctr);
        list.appendChild(li);
      });
    }
    function swapWith(a, b) {
      if (!b) return;
      const t = a.t; a.t = b.t; b.t = t;
      kick(a.uid, 80); kick(b.uid, -80);
      renderAll();
    }

    /* ---------- ceny a akce 2+1 ---------- */
    function lines() {
      const b = curBase();
      const metal = curMetal();
      const out = [];
      if (b) out.push({ price: b.price, promo: b.promo });
      S.items.forEach((x) => {
        const c = charmById[x.pid];
        if (c) out.push({ price: charmVar(c, itemMetal(x)).price, promo: c.promo });
      });
      return out;
    }
    /* Z každých 3 kusů v akci je ten nejlevnější zdarma (stejně jako automatická sleva BXGY). */
    function promoCalc() {
      const all = lines();
      const total = all.reduce((s, l) => s + l.price, 0);
      if (!cfg.promo) return { total, disc: 0, n: 0, inPromo: 0 };
      const p = all.filter((l) => l.promo).map((l) => l.price).sort((a, b) => b - a);
      let disc = 0;
      for (let i = 2; i < p.length; i += 3) disc += p[i];
      return { total, disc, inPromo: p.length };
    }

    function renderTotals() {
      const b = curBase();
      const n = S.items.length;
      const pc = promoCalc();
      const final = pc.total - pc.disc;
      $('sumline').textContent = (b ? SHAPES[b.shape] + ', ' + METALS[b.metal].name.toLowerCase() : 'Bez základu') + ' + ' + n + ' ' + plural(n, 'charm', 'charmy', 'charmů');
      $('add').disabled = !b || !b.av;
      const was = $('was');
      was.hidden = !pc.disc;
      was.textContent = pc.disc ? fmt(pc.total) : '';
      const from = shownTotal, to = final, out = $('total');
      shownTotal = to;
      if (reduced || from == null || from === to) out.textContent = fmt(to);
      else {
        let t0 = null;
        const step = (ts) => {
          if (t0 == null) t0 = ts;
          const k = Math.min(1, (ts - t0) / 420);
          out.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
      const promo = $('promo');
      if (!cfg.promo || !pc.inPromo) { promo.hidden = true; }
      else {
        promo.hidden = false;
        const rest = 3 - (pc.inPromo % 3);
        promo.classList.toggle('is-win', pc.disc > 0);
        if (rest === 1) promo.textContent = pc.disc ? `Ušetříš ${fmt(pc.disc)} · přidej 1 a další je zdarma` : 'Přidej 1 charm a nejlevnější kus je zdarma';
        else if (pc.disc) promo.textContent = `Akce 2+1: ušetříš ${fmt(pc.disc)}`;
        else promo.textContent = 'Akce 2+1: každý třetí kus zdarma';
        promo.title = 'Sleva se odečte automaticky v košíku';
      }
      const tc = $('tabcount');
      if (tc) tc.textContent = n ? String(n) : '';
      const tt = $('totals');
      if (tt) {
        tt.innerHTML = '';
        const row = (cls, a, b) => { const r = el('div', cls); r.append(el('span', null, a), el('b', null, b)); tt.appendChild(r); };
        const pcs = (b ? 1 : 0) + n;
        row('', 'Mezisoučet · ' + pcs + ' ' + plural(pcs, 'kus', 'kusy', 'kusů'), fmt(pc.total));
        if (pc.disc) row('is-disc', 'Akce 2+1', '−' + fmt(pc.disc));
        row('is-total', 'Celkem', fmt(final));
      }
    }
    let lastNudge = -1;
    function nudgePromo() {
      if (!cfg.promo) return;
      const pc = promoCalc();
      if (pc.inPromo % 3 === 0 && pc.disc && pc.inPromo !== lastNudge) {
        lastNudge = pc.inPromo;
        setTimeout(() => toast(`Akce 2+1: nejlevnější kus máš zdarma (−${fmt(pc.disc)})`), 900);
      }
    }

    /* ---------- přepínání kroků ---------- */
    /* Základ a charmy jsou pod sebou (krok se zvýrazní podle posouvání), sestava je samostatný přehled. */
    function markTab(t) {
      if (S.tab === t) return;
      S.tab = t;
      const sum = t === 'sum';
      ['base', 'charms', 'sum'].forEach((k) => {
        const b = root.querySelector('[data-tab="' + k + '"]');
        b.classList.toggle('is-on', k === t);
        if (k === t) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        $('p-' + k).classList.toggle('is-active', k === 'sum' ? sum : !sum);
      });
    }
    function setTab(t) {
      const wasSum = S.tab === 'sum';
      markTab(t);
      const p = $('p-' + t);
      const y = p.getBoundingClientRect().top + window.scrollY - stickyTop() - 8;
      // u přehledu sestavy jen když je jeho začátek mimo obrazovku; základ a charmy se vždy najedou
      if (t !== 'sum' || window.scrollY > y + 2 || p.getBoundingClientRect().top > window.innerHeight * 0.75) scrollToY(y);
      if (t !== 'sum' && wasSum) requestAnimationFrame(spyCats);
    }
    const scrollToY = (y) => {
      y = Math.max(0, y);
      const from = window.scrollY;
      window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
      // pojistka: některé prohlížeče plynulé posouvání nespustí – pak skočíme rovnou
      setTimeout(() => { if (Math.abs(window.scrollY - from) < 2 && Math.abs(y - from) > 2) window.scrollTo(0, y); }, 180);
    };
    /* Horní hrana pro posouvání: kde začíná lepivý filtr charmů (pod hlavičkou webu a kroky, na mobilu pod náhledem). */
    const stickyTop = () => {
      const f = root.querySelector('.cs-filter');
      return f ? parseFloat(getComputedStyle(f).top) || 0 : 0;
    };
    /* Při posouvání stránky se zvýrazní krok a kategorie, ve které právě jsi. */
    function spyAll() {
      if (S.tab === 'sum') return;
      markTab($('p-charms').getBoundingClientRect().top <= stickyTop() + 150 ? 'charms' : 'base');
      spyCats();
    }

    function renderAll() {
      renderStage();
      renderBases();
      renderCharms(true);
      renderSummary();
      renderTotals();
      save();
    }

    /* ---------- uložení, sdílení ---------- */
    function encode() {
      return '2~' + S.base + '~' + sorted().map((x) => x.pid + '@' + Math.round(x.t * 1000) + (x.m ? '@' + x.m[0] : '')).join('.');
    }
    function decode(str) {
      try {
        const parts = str.split('~');
        let baseId, list;
        if (parts[0] === '2') { baseId = parts[1]; list = parts[2] || ''; }
        else { baseId = parts[0].slice(1); list = parts[1] || ''; } // stará verze: b<id>~<variantId>@t
        if (!baseById[baseId]) return false;
        const items = [];
        list.split('.').forEach((s) => {
          if (!s) return;
          const [id, t, m] = s.split('@');
          const c = charmById[id] || charmByVariant[id];
          const mm = { g: 'gold', s: 'silver', r: 'rose' }[m] || null;
          if (c) items.push({ uid: uid(), pid: c.pid, t: clamp((parseInt(t, 10) || 500) / 1000, 0, 1), fresh: true, m: mm });
        });
        S.base = baseId;
        S.items = items.slice(0, maxSetting);
        return true;
      } catch (e) { return false; }
    }
    function save() { try { localStorage.setItem(STORE_KEY, encode()); } catch (e) {} }

    function shareLink() {
      const url = location.href.split('#')[0] + '#navrh=' + encodeURIComponent(encode());
      const copy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(() => toast('Odkaz na tvůj návrh je zkopírovaný'), () => window.prompt('Zkopíruj odkaz:', url));
        } else window.prompt('Zkopíruj odkaz:', url);
      };
      if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) navigator.share({ title: 'Můj šperk na Šperkow', url }).catch(() => {});
      else copy();
    }

    /* ---------- obrázek návrhu (PNG) ---------- */
    function loadForCanvas(src) {
      return new Promise((res) => {
        const im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = () => res(im);
        im.onerror = () => res(null);
        im.src = src;
      });
    }
    async function exportImage() {
      const btn = $('save');
      btn.disabled = true;
      try {
        const SZ = 1080, PAD = 60, k = (SZ - PAD * 2) / 400;
        const cv = document.createElement('canvas');
        cv.width = SZ; cv.height = SZ + 160;
        const cx = cv.getContext('2d');
        const bg = cx.createRadialGradient(SZ / 2, SZ * 0.4, 40, SZ / 2, SZ * 0.4, SZ * 0.8);
        bg.addColorStop(0, '#fafafa'); bg.addColorStop(1, '#e6e6e6');
        cx.fillStyle = bg;
        cx.fillRect(0, 0, cv.width, cv.height);
        const X = (x) => PAD + x * k, Y = (y) => PAD + y * k;
        if (geo.photo) {
          const im = await loadForCanvas(geo.photo.src);
          const r = geo.photo.rect;
          if (im) { cx.save(); cx.shadowColor = 'rgba(0,0,0,.2)'; cx.shadowBlur = 24; cx.shadowOffsetY = 12; cx.drawImage(im, X(r.x), Y(r.y), r.w * k, r.h * k); cx.restore(); }
        } else {
          cx.strokeStyle = METALS[curMetal()].line;
          cx.lineWidth = 3.4 * k;
          cx.lineCap = 'round';
          cx.beginPath();
          geo.pl.pts.forEach((p, i) => (i ? cx.lineTo(X(p[0]), Y(p[1])) : cx.moveTo(X(p[0]), Y(p[1]))));
          cx.stroke();
        }
        const metal = curMetal();
        for (const it of sorted()) {
          const c = charmById[it.pid];
          const v = charmVar(c, itemMetal(it));
          const p = geo.at(it.t);
          let w = CHARM_W * c.scale * k;
          let im = null, ar = 1, svgMode = false;
          if (v.img) {
            const e = imgCache[v.img];
            if (e && e.status === 'ok') { im = e.cv || await loadForCanvas(e.src); ar = e.ar || 1; } else im = await loadForCanvas(v.img);
          } else {
            const blob = new Blob([iconSvg(c.title, itemMetal(it))], { type: 'image/svg+xml' });
            const url = URL.createObjectURL(blob);
            im = await loadForCanvas(url);
            URL.revokeObjectURL(url);
            svgMode = true;
          }
          if (!im) continue;
          if (!svgMode) w *= sizeFactor(ar);
          const h = w * ar;
          const top = Y(p.y) - (svgMode ? 0.06 : 0.04) * h;
          cx.save();
          cx.shadowColor = 'rgba(0,0,0,.25)'; cx.shadowBlur = 16; cx.shadowOffsetY = 10;
          cx.drawImage(im, X(p.x) - w / 2, top, w, h);
          cx.restore();
        }
        cx.fillStyle = '#111';
        cx.font = '64px Anton, Impact, sans-serif';
        cx.textAlign = 'center';
        cx.fillText('ŠPERKOW', SZ / 2, SZ + 70);
        cx.font = '30px Inter, Arial, sans-serif';
        cx.fillStyle = '#666';
        cx.fillText('Můj návrh · sperkow.cz', SZ / 2, SZ + 118);
        const blob = await new Promise((r) => cv.toBlob(r, 'image/png'));
        if (!blob) throw new Error('blob');
        const file = new File([blob], 'muj-sperk-sperkow.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] }) && /Mobi|Android/i.test(navigator.userAgent)) {
          await navigator.share({ files: [file], title: 'Můj šperk na Šperkow' }).catch(() => {});
        } else {
          const a = el('a');
          a.href = URL.createObjectURL(blob);
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
          toast('Obrázek návrhu je uložený');
        }
      } catch (e) {
        toast('Obrázek se nepodařilo vytvořit');
      }
      btn.disabled = false;
    }

    /* ---------- košík ---------- */
    function addToCart() {
      const btn = $('add');
      const b = curBase();
      if (!b) return;
      if (demo) { toast('Ukázka: nejdřív přidej produkty do kolekcí se základy a charmy'); return; }
      const order = sorted();
      if (!order.length && !window.confirm('Nemáš na řetízku žádný charm. Přidat do košíku jen základ?')) return;
      const metal = curMetal();
      const code = 'S' + Date.now().toString(36).toUpperCase().slice(-6);
      const names = order.map((x, i) => { const c = charmById[x.pid]; const vm = charmVar(c, itemMetal(x)).metal; return i + 1 + '. ' + c.title + (vm ? ' (' + METALS[vm].name.toLowerCase() + ')' : ''); }).join(', ');
      const note = ($('note').value || '').trim().slice(0, 240);
      const props = { Sestava: code, 'Charmy zleva doprava': names || 'bez charmů', _cs: 'base' };
      if (note) props['Poznámka'] = note;
      const items = [{ id: Number(b.id) || b.id, quantity: 1, properties: props }];
      order.forEach((x, i) => {
        const v = charmVar(charmById[x.pid], itemMetal(x));
        items.push({ id: Number(v.id) || v.id, quantity: 1, properties: { Sestava: code, Pozice: String(i + 1), _cs: 'charm' } });
      });
      const label = btn.querySelector('span');
      btn.disabled = true;
      label.textContent = 'Přidávám…';
      fetch(cfg.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      })
        .then((r) => r.json().then((j) => { if (!r.ok) throw j; return j; }))
        .then(() => {
          try { localStorage.removeItem(STORE_KEY); } catch (e) {}
          window.location.href = cfg.cartUrl;
        })
        .catch((err) => {
          btn.disabled = false;
          label.textContent = 'Přidat do košíku';
          toast(err && err.description ? err.description : 'Do košíku se to nepodařilo přidat. Zkus to prosím znovu.');
        });
    }

    /* ---------- toast ---------- */
    let toastTimer;
    function toast(msg) {
      const t = $('toast');
      t.textContent = msg;
      t.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => t.classList.remove('is-on'), 2600);
    }

    /* ---------- inspirace ---------- */
    function inspire() {
      const pool = charms.filter((c) => c.av);
      if (!pool.length) return;
      const byCat = {};
      pool.forEach((c) => { (byCat[c.cat] = byCat[c.cat] || []).push(c); });
      const cats = Object.keys(byCat).sort(() => Math.random() - 0.5);
      const want = Math.min(capacity(), 3 + Math.floor(Math.random() * 3));
      const pick = [];
      for (let i = 0; pick.length < want && i < want * 4; i++) {
        const l = byCat[cats[i % cats.length]];
        const c = l[Math.floor(Math.random() * l.length)];
        if (pick.indexOf(c) < 0 || pool.length < want) pick.push(c);
      }
      pushUndo();
      S.items = [];
      S.sel = null;
      S.target = null;
      const n = geo.slots;
      pick.forEach((c, i) => {
        const s = pick.length === 1 ? Math.round((n - 1) / 2) : Math.round((n - 1) / 2 - (pick.length - 1) / 2) + i;
        S.items.push({ uid: uid(), pid: c.pid, t: tOfSlot(clamp(s, 0, n - 1)), fresh: true, m: tileMetal[c.pid] || null });
      });
      normalize(null);
      renderAll();
      S.items.forEach((x, i) => {
        const nd = nodes[x.uid];
        if (nd && !reduced) nd.style.animationDelay = 90 * i + 'ms';
        kick(x.uid, 120 * (i % 2 ? 1 : -1));
      });
      toast('Inspirace: ' + pick.map((c) => c.title).join(', '));
    }

    function spread() {
      pushUndo();
      const order = sorted();
      const n = geo.slots, k = order.length;
      order.forEach((x, i) => {
        x.t = tOfSlot(k === 1 ? Math.round((n - 1) / 2) : Math.round(i * (n - 1) / (k - 1)));
        kick(x.uid, 10);
      });
      renderAll();
      toast('Charmy jsou rozmístěné rovnoměrně');
    }

    /* ---------- nástroj na ruční body (#cs-body) ---------- */
    function setupPicker() {
      const panel = el('div', 'cs-pk');
      panel.innerHTML =
        '<p class="cs-pk-h">Body pro charmy</p>' +
        '<p class="cs-pk-p">Klikni na fotku řetízku zleva doprava, kam se mají charmy věšet. Bod můžeš táhnout, dvojklik ho smaže. Hotový kód vlož do metafieldu <b>custom.charm_points</b> (typ JSON) u produktu se základem.</p>' +
        '<p class="cs-pk-n" data-pk="n"></p>' +
        '<div class="cs-pk-b"><button type="button" data-pk="undo">Zpět</button><button type="button" data-pk="sort">Seřadit zleva</button><button type="button" data-pk="clear">Smazat vše</button><button type="button" data-pk="load">Načíst uložené</button></div>' +
        '<textarea data-pk="out" rows="4" spellcheck="false"></textarea>' +
        '<div class="cs-pk-b"><button type="button" data-pk="copy" class="is-main">Zkopírovat kód</button><button type="button" data-pk="apply">Použít kód z pole</button><button type="button" data-pk="off">Zavřít</button></div>';
      root.appendChild(panel);
      const q = (k) => panel.querySelector('[data-pk="' + k + '"]');
      const P = picker = { active: true, pts: (curBase() && curBase().points || []).map((p) => p.slice()), hist: [] };
      root.classList.add('is-picker');
      const frame = $('frame');
      const box = el('div', 'cs-pk-layer');
      frame.appendChild(box);
      let dragI = -1;
      const toPct = (ev) => {
        const e = geo && geo.photo;
        if (!e) return null;
        const f = toFrame(ev.clientX, ev.clientY);
        const r = e.rect;
        return [+((f.x - r.x) / r.w * 100).toFixed(2), +((f.y - r.y) / r.h * 100).toFixed(2)];
      };
      const sync = () => {
        q('out').value = JSON.stringify({ points: P.pts });
        q('n').textContent = P.pts.length ? `${P.pts.length} ${plural(P.pts.length, 'bod', 'body', 'bodů')}` : 'Zatím žádné body';
        buildGeo();
        P.render();
        renderAll();
      };
      P.render = () => {
        box.innerHTML = '';
        const e = geo && geo.photo;
        if (!e) {
          const b = curBase();
          const st = b && b.stage ? imgCache[b.stage] : null;
          q('n').textContent = !b || !b.stage ? 'Tento základ nemá fotku. Vyber v kroku 1 základ s fotkou.' :
            st && st.status === 'fail' ? 'Fotku se nepodařilo načíst.' : 'Čekám na fotku řetízku…';
          return;
        }
        P.pts.forEach((p, i) => {
          const d = el('span', 'cs-pk-dot', String(i + 1));
          d.style.left = (e.rect.x + p[0] / 100 * e.rect.w) / 4 + '%';
          d.style.top = (e.rect.y + p[1] / 100 * e.rect.h) / 4 + '%';
          d.addEventListener('pointerdown', (ev) => {
            ev.stopPropagation(); ev.preventDefault();
            P.hist.push(JSON.stringify(P.pts));
            dragI = i;
            try { d.setPointerCapture(ev.pointerId); } catch (x) {}
          });
          d.addEventListener('pointermove', (ev) => {
            if (dragI !== i) return;
            const pc = toPct(ev);
            if (!pc) return;
            P.pts[i] = pc;
            d.style.left = (e.rect.x + pc[0] / 100 * e.rect.w) / 4 + '%';
            d.style.top = (e.rect.y + pc[1] / 100 * e.rect.h) / 4 + '%';
          });
          d.addEventListener('pointerup', () => { if (dragI === i) { dragI = -1; sync(); } });
          d.addEventListener('dblclick', (ev) => { ev.stopPropagation(); P.hist.push(JSON.stringify(P.pts)); P.pts.splice(i, 1); sync(); });
          box.appendChild(d);
        });
      };
      box.addEventListener('pointerdown', (ev) => {
        if (ev.target !== box) return;
        const pc = toPct(ev);
        if (!pc) return;
        P.hist.push(JSON.stringify(P.pts));
        P.pts.push(pc);
        sync();
      });
      q('undo').addEventListener('click', () => { if (P.hist.length) { P.pts = JSON.parse(P.hist.pop()); sync(); } });
      q('sort').addEventListener('click', () => { P.hist.push(JSON.stringify(P.pts)); P.pts.sort((a, b) => a[0] - b[0]); sync(); });
      q('clear').addEventListener('click', () => { P.hist.push(JSON.stringify(P.pts)); P.pts = []; sync(); });
      q('load').addEventListener('click', () => { P.hist.push(JSON.stringify(P.pts)); P.pts = (curBase().points || []).map((p) => p.slice()); sync(); });
      q('apply').addEventListener('click', () => {
        const p = parsePoints(q('out').value);
        if (!p) { toast('Kód nejde přečíst'); return; }
        P.hist.push(JSON.stringify(P.pts)); P.pts = p; sync();
      });
      q('copy').addEventListener('click', () => {
        const t = q('out');
        t.select();
        (navigator.clipboard ? navigator.clipboard.writeText(t.value) : Promise.reject()).then(() => toast('Kód je zkopírovaný'), () => { document.execCommand('copy'); toast('Kód je zkopírovaný'); });
      });
      q('off').addEventListener('click', () => {
        P.active = false;
        picker = null;
        panel.remove(); box.remove();
        root.classList.remove('is-picker');
        buildGeo();
        renderAll();
      });
      sync();
    }

    /* ---------- odsazení pod lepivou hlavičkou ---------- */
    function measureHeader() {
      try {
        let bottom = 0;
        const seen = [], cand = [];
        [0.2, 0.5, 0.8].forEach((fx) => [2, 24].forEach((y) => {
          const els = document.elementsFromPoint ? document.elementsFromPoint(window.innerWidth * fx, y) : [];
          for (const e of els) cand.push(e);
        }));
        document.querySelectorAll('header,sticky-header,.header,#header,.shopify-section-group-header-group,[class*="header-sticky"],[class*="sticky-header"]').forEach((e) => cand.push(e));
        for (const e of cand) {
          if (seen.indexOf(e) > -1 || root.contains(e) || e === document.body || e === document.documentElement) continue;
          seen.push(e);
          const cs = getComputedStyle(e);
          if ((cs.position === 'fixed' || cs.position === 'sticky') && cs.visibility !== 'hidden' && cs.display !== 'none') {
            const r = e.getBoundingClientRect();
            if (r.top > 4 || r.bottom <= 0 || r.height > 220 || r.width < 0.5 * window.innerWidth) continue;
            bottom = Math.max(bottom, r.bottom);
          }
        }
        root.style.setProperty('--cs-top', Math.round(clamp(bottom, 0, 180)) + 'px');
      } catch (e) {}
    }

    /* ---------- události ---------- */
    root.querySelectorAll('[data-tab]').forEach((b) => b.addEventListener('click', () => setTab(b.getAttribute('data-tab'))));
    root.querySelectorAll('[data-go]').forEach((b) => b.addEventListener('click', () => setTab(b.getAttribute('data-go'))));
    // kategorie jsou v jednom řádku; kolečko myši je posouvá do strany
    $('cats').addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX) || this.scrollWidth <= this.clientWidth) return;
      e.preventDefault();
      this.scrollLeft += e.deltaY;
    }, { passive: false });
    let spyRaf = false;
    window.addEventListener('scroll', () => {
      if (spyRaf) return;
      spyRaf = true;
      requestAnimationFrame(() => { spyRaf = false; spyAll(); });
    }, { passive: true });
    // plovoucí lišta s cenou jen dokud je editor na obrazovce
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((en) => { root.classList.toggle('is-out', !en[0].isIntersecting); }, { rootMargin: '0px 0px -120px 0px' }).observe($('rail'));
    }
    $('q').addEventListener('input', function () { S.q = this.value.trim(); renderCharms(); });
    $('undo').addEventListener('click', undo);
    $('redo').addEventListener('click', redo);
    $('spread').addEventListener('click', spread);
    $('dice').addEventListener('click', inspire);
    $('clear').addEventListener('click', () => {
      if (!S.items.length) return;
      pushUndo();
      S.items = []; S.sel = null; S.target = null;
      renderAll();
      toast('Řetízek je prázdný. Krok zpět vrátí charmy.');
    });
    $('zoom').addEventListener('click', function () {
      const on = root.classList.toggle('is-zoom');
      this.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('selcard').addEventListener('click', (ev) => { const b = ev.target.closest('[data-act]'); if (b) selAction(b.getAttribute('data-act')); });
    $('target-x').addEventListener('click', () => { S.target = null; renderStage(); renderCharms(true); });
    $('share').addEventListener('click', shareLink);
    $('save').addEventListener('click', exportImage);
    $('add').addEventListener('click', addToCart);
    $('stage').addEventListener('pointerdown', (ev) => {
      if (ev.target.closest('.cs-ch,.cs-selcard,.cs-slot,.cs-dock,.cs-pk-layer')) return;
      if (S.sel || S.target != null) { S.sel = null; S.target = null; renderStage(); renderCharms(true); }
    });
    // jemné světlo a „vánek“ myší
    let lastMx = null;
    $('stage').addEventListener('pointermove', (ev) => {
      if (drag || ev.pointerType !== 'mouse' || reduced) return;
      const st = $('stage');
      const r = st.getBoundingClientRect();
      st.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      st.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      if (lastMx != null && geo) {
        const dx = ev.clientX - lastMx;
        if (Math.abs(dx) > 2) {
          const f = toFrame(ev.clientX, ev.clientY);
          S.items.forEach((x) => { const p = geo.at(x.t); if (Math.hypot(p.x - f.x, p.y + 20 - f.y) < 45) kick(x.uid, -0.9 * dx); });
        }
      }
      lastMx = ev.clientX;
    });
    $('stage').addEventListener('pointerleave', () => { lastMx = null; });
    root.addEventListener('keydown', (ev) => {
      const typing = /INPUT|TEXTAREA/.test(document.activeElement.tagName);
      if ((ev.ctrlKey || ev.metaKey) && ev.key.toLowerCase() === 'z' && !typing) { ev.preventDefault(); ev.shiftKey ? redo() : undo(); }
      if ((ev.ctrlKey || ev.metaKey) && ev.key.toLowerCase() === 'y' && !typing) { ev.preventDefault(); redo(); }
      if (ev.key === 'Escape' && (S.sel || S.target != null)) { S.sel = null; S.target = null; renderStage(); renderCharms(true); }
    });

    /* ---------- start ---------- */
    if (demo) $('demo').hidden = false;
    const hash = (location.hash.match(/navrh=([^&]+)/) || [])[1];
    let loaded = false;
    if (hash) loaded = decode(decodeURIComponent(hash));
    if (!loaded) {
      try {
        const s = localStorage.getItem(STORE_KEY) || localStorage.getItem('spw-charm-studio-v1');
        if (s) loaded = decode(s);
      } catch (e) {}
    }
    // odkaz z menu: ?tvar=naramek / ?tvar=nahrdelnik otevře editor rovnou s tímto typem šperku
    const wantShape = (location.search.match(/[?&]tvar=(naramek|nahrdelnik)/) || [])[1];
    if (wantShape && curShape() !== wantShape) {
      const wb = pickBase((b) => b.shape === wantShape && b.metal === curMetal()) || pickBase((b) => b.shape === wantShape);
      if (wb) S.base = wb.id;
    }
    ensureStage();
    renderCats();
    renderCharms();
    renderAll();
    spyAll();
    if (loaded && S.items.length) {
      S.items.forEach((x, i) => kick(x.uid, 80 * (i % 2 ? 1 : -1)));
      if (hash) toast('Načetli jsme sdílený návrh');
    }
    if (/cs-body/.test(location.hash + location.search)) {
      const go = () => setupPicker();
      const b = curBase();
      if (b && b.stage && imgCache[b.stage] && imgCache[b.stage].status === 'loading') loadImage(b.stage, processChain, go, true); else go();
    }

    let sT1, sT2, sRaf = false;
    window.addEventListener('scroll', () => {
      clearTimeout(sT1); clearTimeout(sT2);
      sT1 = setTimeout(measureHeader, 220);
      sT2 = setTimeout(measureHeader, 650);
      if (!sRaf) { sRaf = true; requestAnimationFrame(() => { sRaf = false; measureHeader(); }); }
    }, { passive: true });
    function placeBar() {
      const r = $('rail').getBoundingClientRect();
      root.style.setProperty('--bar-x', Math.round(r.left + r.width / 2) + 'px');
      root.style.setProperty('--bar-w', Math.round(r.width) + 'px');
    }
    placeBar();
    window.addEventListener('resize', placeBar);
    window.addEventListener('load', placeBar);
    measureHeader();
    setTimeout(measureHeader, 400);
    setTimeout(measureHeader, 1500);
    window.addEventListener('load', measureHeader);
    let lastW = window.innerWidth;
    window.addEventListener('resize', () => { if (window.innerWidth !== lastW) { lastW = window.innerWidth; measureHeader(); } });

    // pro testy
    root.__cs = { S, get geo() { return geo; }, addCharm: (i, s) => addCharm(charms[i], s), charms, bases, promoCalc, encode, decode, renderAll, setTab, selAction, undo, redo, inspire, spread, exportImage, chooseBase };
  }

  if (/cs-debug/.test(location.search)) window.__csDbg = { keyImage, mainObject }; // test/photos.html
  /* Pro jiné sekce webu (banner Charmy na úvodní stránce): vyčištěná fotka charmu bez pozadí, kót a textu. */
  window.spwCleanCharm = (url, cb) => loadImage(url, processCharm, (e) => cb(e.status === 'ok' ? e.src : null));
  function boot() { document.querySelectorAll('.cs[data-sid]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

